const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2475 1650",
    style: {
      enableBackground: "new 0 0 2475 1650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2475,
    height: 1650
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1618.1871,
    y1: 852.7278,
    x2: 583.7487,
    y2: 852.7278,
    gradientTransform: "matrix(-1 0 0 1 774 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M1312.553,1444.501c0,0,746.088,7.401,953.906-159.07 c207.818-166.47,129.594-332.431-29.53-379.445c-159.125-47.014-186.266-95.906-100.645-161.858 c85.622-65.952,194.366-201.329,13.809-337.375c-180.557-136.046-386.58,59.362-547.956,33.414 c-161.376-25.948-97.461-113.341-309.683-52.987c-212.222,60.353-165.43-115.37-336.042-131.297 c-170.612-15.928-153.125,182.773-328.613,107.768c-175.489-75.004-319.028-64.654-394.475,54.462 c-75.446,119.116-58.879,357.379,106.638,452.991c165.517,95.612,163.958,11.261,102.099,105.213 c-61.858,93.952-117.327,402.914,164.28,447.042C887.949,1467.488,1312.553,1444.501,1312.553,1444.501z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M576.929,482.931l-47.373,101.738c-12.55,26.954-12.062,58.171,1.325,84.719l80.353,159.347 c9.111,18.068,12.35,38.531,9.266,58.529l-13.446,87.175c-5.04,32.676,6.891,65.671,31.663,87.567l0,0 c39.316,34.751,99.126,31.986,135.069-6.243l56.989-60.615c26.716-28.417,33.84-70.06,18.088-105.741l-51.952-117.678 c-6.637-15.035-9.35-31.508-7.886-47.878l15.1-168.727c3.481-38.897-16.676-76.096-51.164-94.418l-42.432-22.543 C661.394,412.06,600.415,432.493,576.929,482.931z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M712.909,1108.243c-0.27,0.018-0.544,0.014-0.822-0.014c-2.726-0.271-4.717-2.7-4.446-5.427 c25.142-253.211-46.787-521.912-53.177-535.455c-1.269-1.668-1.382-4.029-0.118-5.841c1.566-2.246,4.658-2.799,6.906-1.23 c1.433,1,2.38,1.66,6.585,16.154c1.938,6.681,5.134,18.349,9.35,36c6.335,26.516,15.724,69.73,24.489,125.016 c14.646,92.382,29.282,230.928,15.837,366.337C717.27,1106.232,715.286,1108.087,712.909,1108.243z M655.565,568.405 c0.004,0.002,0.007,0.005,0.011,0.008C655.573,568.41,655.569,568.407,655.565,568.405z M655.556,568.399l0.002,0.001 C655.558,568.4,655.557,568.399,655.556,568.399z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2000.968,1157.146c25.927-40.767,35.952-86.023,31.052-125.58 c-4.381-35.361,4.828-71.195,26.298-99.589c2.257-2.984,4.42-6.097,6.479-9.334c31.182-49.03,26.419-107.883-10.639-131.451 c-37.058-23.568-92.378-2.928-123.56,46.102c-6.377,10.026-11.247,20.461-14.645,30.92 c-10.844,33.381-33.487,61.855-64.288,78.713c-27.526,15.066-53.04,38.604-72.478,69.168 c-28.991,45.585-38.101,96.784-28.694,139.35c3.558,16.101,4.195,32.773,1.753,49.068c-4.058,27.077,4.949,52.901,25.754,66.133 c22.444,14.274,52.337,9.898,76.113-8.53c13.454-10.428,28.789-18.073,45.032-23.204 C1937.492,1226.801,1974.754,1198.364,2000.968,1157.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2033.962,851.603c-15.767,35.483-32.661,70.43-49.921,105.201 c-4.311,8.695-8.761,17.319-13.183,25.957l-6.636,12.957l-6.744,12.901c-4.529,8.583-8.94,17.229-13.567,25.762l-13.878,25.597 c-9.47,16.947-18.795,33.973-28.58,50.742c-4.88,8.391-9.596,16.876-14.647,25.169l-15.034,24.942 c-20.381,33.052-41.601,65.606-64.428,97.024l-1.364-0.97l16.184-24.157l4.057-6.028l3.907-6.13l7.79-12.273l7.812-12.256 c2.611-4.08,5.071-8.258,7.614-12.382c5.031-8.282,10.126-16.524,15.103-24.838c19.693-33.389,38.942-67.039,57.495-101.082 c9.146-17.092,18.438-34.105,27.466-51.262l6.806-12.848l6.698-12.906c4.471-8.601,8.942-17.203,13.325-25.849 c8.915-17.218,17.707-34.5,26.358-51.854c8.742-17.308,17.323-34.703,25.847-52.118L2033.962,851.603z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M752.753,1034.005c-30.278-44.365-72.115-74.451-114.675-86.791 c-38.046-11.031-70.615-36.153-90.207-70.537c-2.059-3.614-4.291-7.19-6.695-10.712c-36.415-53.356-98.627-74.298-138.955-46.774 c-40.328,27.523-43.5,93.089-7.085,146.444c7.446,10.911,15.971,20.462,25.166,28.52c29.346,25.716,48.507,61.334,52.222,100.193 c3.321,34.727,16.179,71.114,38.879,104.375c33.856,49.607,82.166,81.365,129.777,90.421 c18.009,3.425,35.32,10.086,50.896,19.726c25.882,16.019,56.214,18.142,78.855,2.69c24.424-16.67,33.063-49.127,24.663-81.497 c-4.753-18.318-5.838-37.335-3.958-56.18C796.076,1129.397,783.366,1078.86,752.753,1034.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M455.08,866.314c29.335,31.667,57.628,64.251,85.581,97.131 c6.992,8.217,13.851,16.545,20.737,24.851l10.327,12.461l10.222,12.547c6.783,8.391,13.681,16.689,20.369,25.157l20.064,25.402 c13.16,17.105,26.464,34.099,39.305,51.448c6.433,8.665,13.033,17.203,19.29,26l18.888,26.296 c24.828,35.314,48.78,71.27,70.867,108.366l-1.589,0.968l-17.582-27.126l-4.379-6.789l-4.549-6.68l-9.122-13.34l-9.095-13.355 c-3.023-4.457-6.213-8.802-9.311-13.208c-6.255-8.771-12.44-17.591-18.752-26.321c-25.474-34.76-51.41-69.181-78.053-103.062 c-13.451-16.839-26.756-33.792-40.325-50.538l-10.142-12.587l-10.247-12.502c-6.826-8.339-13.653-16.679-20.564-24.949 c-13.68-16.658-27.48-33.219-41.416-49.667c-13.848-16.521-27.857-32.915-41.909-49.259L455.08,866.314z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1573.159,1223.277c-90.715-51.229-136.543-184.903-98.612-235.023 c32.897-43.468,117.25-8.838,137.728-49.258c24.598-48.552-84.513-123.369-61.361-180.176 c22.206-54.484,138.597-24.971,161.982-78.868c24.979-57.569-94.437-122.066-78.235-204.002 c13.512-68.335,116.882-126.178,211.032-108.091c76.62,14.719,153.951,81.035,149.437,140.853 c-6.161,81.649-160.56,94.841-164.633,174.505c-3.759,73.511,125.304,109.336,116.658,174.613 c-9.307,70.263-165.831,81.583-166.559,138.06c-0.639,49.623,119.913,62.799,123.376,112.599 C1908.551,1174.343,1708.049,1299.453,1573.159,1223.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1811.115,468.208c-8.213,60.034-18.128,119.766-28.779,179.354 c-5.236,29.813-10.988,59.522-16.622,89.258c-2.871,14.856-5.938,29.672-8.905,44.51c-3.001,14.829-5.918,29.679-9.132,44.464 l-9.532,44.378c-3.288,14.769-6.5,29.556-9.902,44.299l-2.524,11.063l-2.619,11.042l-5.238,22.084l-5.281,22.072l-5.589,21.999 c-14.897,58.627-30.762,117.167-51.617,173.96l-1.127-0.387c16.265-58.204,29.62-117.112,42.792-176.072l4.924-22.111 l4.791-22.147l4.833-22.135l2.416-11.067l2.322-11.091c3.052-14.799,6.295-29.552,9.46-44.324l9.255-44.375l36.994-177.544 c12.315-59.198,24.781-118.375,37.912-177.449L1811.115,468.208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1523.239,1012.994l-5.483-1.517c-0.633-0.175-1.005-0.831-0.83-1.465 c0.175-0.633,0.831-1.005,1.464-0.83c0.007,0.002,0.014,0.004,0.021,0.006l0.062,0.019l5.336,1.61l0.054,0.016 c0.595,0.179,0.931,0.807,0.752,1.401C1524.439,1012.821,1523.826,1013.156,1523.239,1012.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1507.009,1007.625l-10.33-4.879c-0.725-0.342-1.035-1.207-0.693-1.932 c0.342-0.725,1.207-1.034,1.932-0.692c0.008,0.004,0.016,0.007,0.024,0.011l0.13,0.065l9.978,4.998l0.114,0.057 c0.651,0.326,0.915,1.118,0.589,1.77C1508.429,1007.665,1507.654,1007.93,1507.009,1007.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1486.851,996.909l-9.25-6.721c-0.746-0.542-0.912-1.587-0.369-2.333 c0.542-0.746,1.587-0.912,2.333-0.37c0.005,0.004,0.011,0.008,0.016,0.012l0.123,0.093l8.904,6.707l0.112,0.085 c0.693,0.522,0.832,1.507,0.309,2.201C1488.514,997.269,1487.543,997.411,1486.851,996.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1468.963,982.695l-7.995-8.18c-0.72-0.737-0.707-1.918,0.03-2.638 c0.737-0.72,1.918-0.707,2.638,0.03c0.005,0.005,0.01,0.011,0.016,0.016l0.109,0.115l7.652,8.104l0.099,0.104 c0.67,0.71,0.638,1.828-0.072,2.497C1470.738,983.407,1469.635,983.382,1468.963,982.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1453.639,965.731l-6.647-9.315c-0.661-0.926-0.446-2.213,0.48-2.874 c0.926-0.661,2.213-0.446,2.874,0.48c0.005,0.007,0.01,0.014,0.014,0.02l0.092,0.134l6.316,9.182l0.083,0.121 c0.614,0.893,0.388,2.114-0.504,2.728C1455.465,966.815,1454.259,966.599,1453.639,965.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1441.039,946.639l-5.244-10.179c-0.571-1.107-0.135-2.468,0.972-3.038 c1.107-0.571,2.468-0.135,3.038,0.972c0.004,0.008,0.008,0.016,0.012,0.024l0.075,0.152l4.93,9.989l0.068,0.137 c0.527,1.068,0.089,2.362-0.979,2.889C1442.855,948.107,1441.577,947.682,1441.039,946.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1431.269,925.926l-3.784-10.818c-0.447-1.278,0.226-2.676,1.504-3.122 c1.278-0.447,2.676,0.226,3.123,1.504c0.003,0.009,0.006,0.019,0.01,0.028l0.057,0.173l3.493,10.566l0.051,0.155 c0.408,1.233-0.262,2.564-1.495,2.971C1433.007,927.786,1431.692,927.134,1431.269,925.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1424.485,904.039l-2.207-11.261c-0.274-1.398,0.637-2.754,2.035-3.028 c1.398-0.274,2.754,0.637,3.028,2.035l0.005,0.027l0.033,0.18l2.023,10.928l0.032,0.175c0.253,1.368-0.651,2.683-2.019,2.936 C1426.057,906.284,1424.751,905.392,1424.485,904.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1420.88,881.381l-0.556-11.486c-0.072-1.489,1.076-2.754,2.565-2.826 c1.489-0.072,2.754,1.076,2.826,2.565l0.001,0.028l0.007,0.203l0.42,11.092l0.007,0.197c0.055,1.456-1.081,2.681-2.536,2.736 C1422.169,883.944,1420.951,882.822,1420.88,881.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1420.617,858.424l1.039-11.424c0.141-1.55,1.512-2.693,3.062-2.552 c1.55,0.141,2.692,1.512,2.551,3.062l-0.003,0.03l-0.018,0.177l-1.124,11.06l-0.018,0.175c-0.154,1.515-1.507,2.619-3.022,2.465 C1421.58,861.264,1420.481,859.927,1420.617,858.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1423.408,835.666l2.434-11.205c0.344-1.585,1.909-2.591,3.494-2.247 c1.585,0.344,2.591,1.909,2.247,3.494l-0.007,0.031l-0.039,0.169l-2.475,10.841l-0.038,0.169 c-0.354,1.549-1.896,2.518-3.445,2.164C1424.04,838.73,1423.074,837.204,1423.408,835.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1428.926,813.421l3.698-10.846c0.545-1.598,2.282-2.451,3.88-1.907 c1.598,0.545,2.452,2.282,1.907,3.88l-0.01,0.03l-0.056,0.157l-3.701,10.493l-0.055,0.157c-0.551,1.56-2.262,2.379-3.823,1.829 C1429.215,816.667,1428.398,814.973,1428.926,813.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1436.899,791.946l4.815-10.391c0.738-1.591,2.625-2.284,4.217-1.546 c1.592,0.737,2.284,2.626,1.546,4.217l-0.014,0.03l-0.068,0.143l-4.788,10.053l-0.068,0.143 c-0.74,1.554-2.599,2.213-4.153,1.473C1436.843,795.334,1436.183,793.493,1436.899,791.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1447.034,771.418l5.791-9.872c0.921-1.57,2.94-2.096,4.51-1.175 c1.57,0.921,2.096,2.94,1.175,4.51l-0.018,0.03l-0.078,0.13l-5.739,9.551l-0.078,0.13c-0.92,1.531-2.908,2.027-4.439,1.107 C1446.637,774.913,1446.139,772.945,1447.034,771.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1459.056,751.949l6.649-9.312c1.094-1.532,3.224-1.888,4.756-0.794 c1.533,1.094,1.888,3.224,0.794,4.756l-0.019,0.027l-0.086,0.117l-6.568,9.013l-0.085,0.118 c-1.091,1.497-3.189,1.826-4.686,0.735C1458.323,755.524,1457.99,753.444,1459.056,751.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1472.765,733.639l7.421-8.698c1.236-1.449,3.413-1.621,4.862-0.385 c1.449,1.236,1.622,3.413,0.385,4.862l-0.008,0.009l-0.09,0.105l-7.27,8.461l-0.091,0.106c-1.234,1.436-3.399,1.6-4.835,0.366 C1471.703,737.232,1471.531,735.076,1472.765,733.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1487.947,716.549l8.082-8.082c1.362-1.362,3.571-1.362,4.933,0c1.362,1.362,1.362,3.571,0,4.933 l-0.009,0.009l-0.096,0.095l-7.918,7.863l-0.096,0.095c-1.359,1.35-3.555,1.342-4.905-0.017 C1486.588,720.086,1486.587,717.898,1487.947,716.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1504.422,700.697c2.848-2.537,5.767-4.987,8.682-7.444c1.49-1.256,3.716-1.066,4.972,0.424 c1.256,1.49,1.066,3.716-0.424,4.972l-0.009,0.007l-0.055,0.046c-2.856,2.391-5.718,4.776-8.507,7.242 c-1.451,1.284-3.669,1.148-4.953-0.304C1502.844,704.19,1502.97,701.981,1504.422,700.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1522.051,686.138l9.192-6.78c1.585-1.17,3.819-0.832,4.988,0.753s0.832,3.819-0.753,4.988 l-0.01,0.008l-0.104,0.076l-9.008,6.596l-0.104,0.076c-1.581,1.157-3.8,0.814-4.958-0.766 C1520.137,689.508,1520.47,687.295,1522.051,686.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1540.666,672.916l9.643-6.102c1.683-1.065,3.911-0.564,4.976,1.119 c1.065,1.683,0.564,3.911-1.119,4.977l-0.011,0.007l-0.107,0.067l-9.449,5.934l-0.107,0.068 c-1.678,1.053-3.891,0.547-4.945-1.13C1538.493,676.177,1538.989,673.969,1540.666,672.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1560.158,661.055l10.042-5.415c1.772-0.956,3.984-0.294,4.94,1.479 c0.956,1.772,0.294,3.984-1.479,4.94l-0.011,0.006l-0.11,0.059l-9.84,5.262l-0.111,0.059c-1.766,0.944-3.963,0.278-4.908-1.488 C1557.737,664.19,1558.392,661.999,1560.158,661.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1580.422,650.572l10.39-4.719c1.853-0.842,4.038-0.022,4.88,1.832 c0.842,1.853,0.022,4.038-1.832,4.88l-0.012,0.005l-0.113,0.051l-10.18,4.581l-0.113,0.051 c-1.846,0.831-4.016,0.008-4.847-1.838C1577.765,653.567,1578.576,651.402,1580.422,650.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1601.358,641.485l10.688-4.015c1.926-0.724,4.074,0.251,4.797,2.177 c0.724,1.926-0.251,4.073-2.177,4.797l-0.012,0.005l-0.116,0.043l-10.47,3.892l-0.116,0.043 c-1.918,0.713-4.051-0.264-4.764-2.182C1598.475,644.326,1599.44,642.198,1601.358,641.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1622.864,633.81l10.935-3.302c1.99-0.601,4.091,0.525,4.692,2.516 c0.601,1.99-0.525,4.091-2.516,4.692l-0.013,0.004l-0.118,0.035l-10.71,3.193l-0.118,0.036 c-1.982,0.591-4.068-0.537-4.658-2.519C1619.767,636.483,1620.882,634.401,1622.864,633.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1644.839,627.566l11.134-2.58c2.047-0.474,4.09,0.8,4.564,2.847 c0.474,2.047-0.8,4.09-2.847,4.564l-0.013,0.003l-0.121,0.028l-10.901,2.487l-0.121,0.028c-2.038,0.465-4.066-0.81-4.531-2.848 C1641.54,630.056,1642.802,628.031,1644.839,627.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1667.175,622.772l11.272-1.827c2.083-0.338,4.046,1.078,4.384,3.161 c0.338,2.084-1.078,4.047-3.161,4.384l-0.122,0.02l-11.025,1.79l-0.123,0.02c-2.084,0.338-4.048-1.077-4.387-3.161 C1663.674,625.074,1665.089,623.11,1667.175,622.772L1667.175,622.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1689.773,619.496l11.368-1.078c2.089-0.198,3.942,1.334,4.14,3.423 c0.198,2.088-1.334,3.942-3.423,4.14l-0.116,0.011l-11.118,1.077l-0.124,0.012c-2.095,0.203-3.957-1.331-4.16-3.425 c-0.203-2.094,1.33-3.957,3.425-4.16L1689.773,619.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1712.549,617.713l11.423-0.329c2.084-0.06,3.822,1.581,3.882,3.665 c0.06,2.084-1.581,3.822-3.665,3.882l-0.117,0.004l-11.172,0.345l-0.125,0.004c-2.091,0.065-3.838-1.578-3.902-3.668 c-0.064-2.091,1.578-3.838,3.668-3.902L1712.549,617.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1735.397,617.433l11.415,0.43c2.071,0.078,3.686,1.82,3.608,3.89 c-0.078,2.071-1.82,3.686-3.891,3.608l-0.118-0.004l-11.164-0.398l-0.126-0.004c-2.077-0.074-3.701-1.818-3.627-3.895 c0.074-2.077,1.818-3.701,3.895-3.627L1735.397,617.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1758.204,618.677l11.357,1.199c2.048,0.216,3.532,2.052,3.316,4.099 c-0.216,2.048-2.052,3.533-4.099,3.316l-0.119-0.012l-11.106-1.15l-0.126-0.013c-2.055-0.213-3.548-2.051-3.335-4.105 c0.213-2.055,2.051-3.548,4.106-3.335L1758.204,618.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1780.867,621.464l11.243,1.977c2.015,0.354,3.362,2.275,3.007,4.291 c-0.354,2.015-2.276,3.362-4.291,3.007l-0.12-0.021l-10.993-1.91l-0.127-0.022c-2.023-0.352-3.377-2.276-3.026-4.299 c0.351-2.023,2.276-3.377,4.298-3.026L1780.867,621.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1803.277,625.81l11.078,2.764c1.973,0.492,3.173,2.491,2.681,4.463 c-0.492,1.973-2.491,3.173-4.464,2.681l-0.12-0.03l-10.829-2.678l-0.127-0.031c-1.98-0.49-3.189-2.492-2.699-4.472 c0.49-1.98,2.492-3.189,4.472-2.699L1803.277,625.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1825.329,631.733l10.857,3.557c1.92,0.629,2.967,2.695,2.338,4.616 c-0.629,1.92-2.696,2.966-4.615,2.337l-0.12-0.039l-10.61-3.452l-0.127-0.041c-1.927-0.627-2.982-2.698-2.355-4.626 c0.627-1.927,2.698-2.982,4.626-2.355L1825.329,631.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1846.909,639.241l10.56,4.264c1.862,0.752,2.762,2.87,2.01,4.732 c-0.752,1.862-2.87,2.762-4.732,2.01l-0.076-0.031l-10.394-4.172l-0.092-0.037c-1.869-0.75-2.776-2.874-2.026-4.743 c0.75-1.869,2.874-2.776,4.743-2.026L1846.909,639.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1867.906,647.987l10.348,4.616c1.822,0.813,2.64,2.949,1.827,4.771 c-0.813,1.822-2.949,2.64-4.771,1.827l-0.023-0.01l-10.29-4.565l-0.038-0.017c-1.829-0.812-2.655-2.953-1.843-4.783 c0.812-1.829,2.953-2.654,4.782-1.843L1867.906,647.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1888.547,657.276l10.273,4.654l0.019,0.008c1.805,0.818,2.606,2.945,1.788,4.75 c-0.818,1.805-2.938,2.609-4.744,1.791l-10.312-4.646c-1.813-0.817-2.621-2.949-1.804-4.762 c0.817-1.813,2.949-2.621,4.762-1.804l0.007,0.003L1888.547,657.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1909.107,666.491l10.332,4.389l0.068,0.029c1.813,0.77,2.658,2.863,1.888,4.676 c-0.77,1.813-2.856,2.661-4.669,1.891l-10.469-4.421c-1.82-0.769-2.672-2.867-1.904-4.687c0.769-1.82,2.867-2.672,4.687-1.904 l0.007,0.003L1909.107,666.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1929.845,675.015l10.503,3.793l0.125,0.045c1.84,0.664,2.793,2.695,2.128,4.534 c-0.664,1.84-2.688,2.795-4.527,2.131l-10.752-3.857c-1.847-0.663-2.808-2.698-2.145-4.545c0.663-1.847,2.698-2.807,4.545-2.145 l0.007,0.003L1929.845,675.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1950.966,682.163l10.74,2.814l0.191,0.05c1.879,0.492,3.004,2.415,2.511,4.294 c-0.492,1.879-2.408,3.005-4.287,2.513l-11.118-2.888c-1.887-0.49-3.019-2.417-2.529-4.303c0.49-1.887,2.417-3.019,4.304-2.529 l0.007,0.002L1950.966,682.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1972.56,687.141l10.946,1.406l0.26,0.034c1.914,0.246,3.265,1.996,3.02,3.91 c-0.246,1.914-1.989,3.267-3.903,3.02l-11.46-1.448c-1.921-0.243-3.281-1.996-3.038-3.917c0.243-1.921,1.996-3.281,3.917-3.038 l0.007,0.001L1972.56,687.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1994.5,689.097l10.98-0.385l0.308-0.011c1.915-0.067,3.521,1.43,3.588,3.345 c0.067,1.914-1.423,3.521-3.338,3.588l-11.59,0.431c-1.921,0.072-3.536-1.428-3.608-3.349c-0.071-1.921,1.428-3.536,3.349-3.608 l0.007,0L1994.5,689.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2016.349,687.319l10.661-2.483l0.336-0.078c1.853-0.432,3.705,0.72,4.136,2.573 c0.432,1.853-0.714,3.703-2.566,4.134l-11.333,2.664c-1.858,0.437-3.719-0.715-4.156-2.573 c-0.437-1.858,0.715-3.719,2.574-4.156l0.007-0.002L2016.349,687.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2037.385,681.307l10.004-4.507l0.29-0.131c1.723-0.776,3.749-0.009,4.526,1.714 c0.776,1.723,0.015,3.746-1.708,4.523l-10.579,4.792c-1.728,0.783-3.762,0.016-4.545-1.711 c-0.783-1.727-0.017-3.762,1.711-4.545l0.006-0.003L2037.385,681.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2056.95,671.389l9.065-6.23l0.24-0.165c1.542-1.06,3.652-0.669,4.712,0.873 c1.06,1.542,0.68,3.644-0.862,4.704l-9.524,6.601c-1.549,1.073-3.674,0.688-4.747-0.861c-1.073-1.548-0.688-3.674,0.861-4.747 l0.011-0.008L2056.95,671.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2074.534,658.183l7.922-7.662l0.195-0.188c1.317-1.274,3.418-1.239,4.692,0.078 c1.269,1.312,1.238,3.402-0.063,4.678l-8.264,8.093c-1.323,1.296-3.447,1.274-4.743-0.049c-1.296-1.323-1.274-3.447,0.049-4.743 l0.015-0.015L2074.534,658.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2089.733,642.242l6.6-8.849l0.156-0.209c1.073-1.438,3.108-1.734,4.545-0.661 c1.432,1.068,1.731,3.092,0.674,4.529l-6.855,9.311c-1.075,1.461-3.131,1.773-4.592,0.697c-1.461-1.075-1.773-3.131-0.698-4.592 l0.012-0.016L2089.733,642.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2102.202,624.049l5.095-9.787l0.12-0.231c0.81-1.556,2.729-2.161,4.286-1.351 c1.55,0.807,2.156,2.715,1.36,4.268l-5.271,10.282c-0.81,1.579-2.746,2.203-4.326,1.394c-1.579-0.81-2.203-2.746-1.394-4.326 l0.009-0.018L2102.202,624.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2111.572,604.084l3.398-10.49l0.083-0.255c0.529-1.633,2.28-2.527,3.913-1.998 c1.626,0.527,2.519,2.268,2.004,3.894l-3.494,11.021c-0.525,1.655-2.291,2.571-3.946,2.046 c-1.655-0.525-2.571-2.291-2.046-3.946l0.006-0.019L2111.572,604.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2117.441,582.858l0.775-5.452c0.232-1.822,0.583-3.626,0.719-5.463 c0.125-1.674,1.582-2.93,3.256-2.805c1.668,0.124,2.921,1.572,2.806,3.238l-0.007,0.099c-0.132,1.921-0.482,3.826-0.715,5.739 l-0.784,5.735c-0.229,1.681-1.779,2.858-3.46,2.628c-1.681-0.23-2.858-1.779-2.628-3.461l0.002-0.016L2117.441,582.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2119.472,560.916l-0.381-11.035l-0.008-0.242c-0.056-1.637,1.225-3.01,2.862-3.067 c1.631-0.056,2.999,1.216,3.066,2.844l0.469,11.521c0.068,1.657-1.221,3.054-2.877,3.122c-1.656,0.068-3.054-1.221-3.122-2.877 l-0.001-0.019L2119.472,560.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2117.818,538.903l-2.141-10.855l-0.044-0.223c-0.31-1.569,0.711-3.092,2.281-3.401 c1.563-0.308,3.08,0.704,3.398,2.263l2.301,11.29c0.323,1.587-0.701,3.135-2.287,3.458s-3.135-0.701-3.458-2.287l-0.004-0.018 L2117.818,538.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2112.693,517.384l-3.802-10.408l-0.075-0.205c-0.535-1.466,0.219-3.088,1.685-3.623 c1.46-0.533,3.075,0.214,3.617,1.668l4.02,10.796c0.552,1.481-0.202,3.128-1.683,3.68c-1.481,0.551-3.128-0.202-3.68-1.683 l-0.006-0.017L2112.693,517.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2104.298,496.889l-5.361-9.701l-0.104-0.188c-0.736-1.332-0.253-3.008,1.079-3.744 c1.326-0.733,2.995-0.256,3.735,1.064l5.633,10.044c0.754,1.344,0.275,3.045-1.069,3.799c-1.344,0.754-3.045,0.275-3.799-1.069 l-0.009-0.015L2104.298,496.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2092.835,477.941l-6.814-8.726l-0.134-0.171c-0.913-1.168-0.705-2.855,0.463-3.768 c1.164-0.909,2.843-0.706,3.757,0.451l7.139,9.025c0.932,1.178,0.732,2.889-0.446,3.821c-1.178,0.932-2.889,0.732-3.821-0.446 l-0.01-0.013L2092.835,477.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2078.521,461.074l-4.054-3.769c-1.36-1.247-2.674-2.547-4.102-3.718 c-1.117-0.916-1.28-2.564-0.364-3.681c0.913-1.113,2.552-1.279,3.669-0.374l0.053,0.043c1.492,1.21,2.87,2.549,4.293,3.838 l4.241,3.898c1.078,0.99,1.148,2.667,0.158,3.744c-0.99,1.078-2.667,1.148-3.744,0.158l-0.011-0.01L2078.521,461.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2061.601,446.816l-9.296-6.022l-0.175-0.113c-1.179-0.764-1.515-2.338-0.752-3.517 c0.761-1.174,2.327-1.512,3.504-0.76l9.687,6.19c1.2,0.767,1.552,2.362,0.784,3.562c-0.767,1.2-2.362,1.552-3.562,0.784 l-0.013-0.008L2061.601,446.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2042.544,435.538l-10.156-4.473l-0.178-0.078c-1.249-0.55-1.815-2.008-1.266-3.257 c0.548-1.243,1.997-1.81,3.242-1.272l10.545,4.561c1.272,0.55,1.857,2.027,1.307,3.298c-0.55,1.272-2.027,1.857-3.298,1.307 l-0.015-0.007L2042.544,435.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2021.912,427.37l-10.738-2.877l-0.175-0.047c-1.251-0.335-1.994-1.621-1.659-2.872 c0.333-1.242,1.605-1.983,2.847-1.665l11.125,2.848c1.289,0.33,2.066,1.643,1.736,2.932c-0.33,1.289-1.642,2.066-2.931,1.736 c-0.004-0.001-0.009-0.002-0.013-0.003L2021.912,427.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2000.241,422.452l-11.061-1.189l-0.173-0.018c-1.219-0.131-2.101-1.226-1.97-2.445 c0.13-1.211,1.211-2.089,2.42-1.973l11.422,1.1c1.255,0.121,2.175,1.237,2.054,2.492c-0.121,1.256-1.237,2.175-2.492,2.055 c-0.004-0.001-0.008-0.001-0.013-0.001L2000.241,422.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1978.064,420.944l-11.103,0.568l-0.17,0.009c-1.155,0.059-2.14-0.829-2.199-1.985 c-0.059-1.147,0.818-2.126,1.962-2.198l11.439-0.713c1.19-0.074,2.214,0.83,2.288,2.02c0.074,1.19-0.83,2.214-2.02,2.288 c-0.004,0-0.008,0.001-0.012,0.001L1978.064,420.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1955.939,422.984l-5.441,1.152l-2.722,0.575c-0.911,0.173-1.803,0.444-2.706,0.661l-0.08,0.019 c-1.058,0.255-2.123-0.397-2.377-1.455c-0.253-1.05,0.388-2.107,1.433-2.372c0.925-0.234,1.835-0.521,2.772-0.711l2.797-0.625 l5.596-1.248c1.096-0.245,2.183,0.446,2.427,1.542c0.244,1.096-0.446,2.183-1.542,2.427l-0.021,0.005L1955.939,422.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1934.342,428.546l-10.665,3.597l-0.027,0.009c-0.966,0.326-2.013-0.193-2.339-1.159 c-0.324-0.959,0.187-1.999,1.14-2.332l10.698-3.741c0.995-0.348,2.084,0.177,2.432,1.172c0.348,0.995-0.177,2.084-1.172,2.432 c-0.003,0.001-0.007,0.003-0.01,0.004L1934.342,428.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1912.97,435.806l-10.867,3.366c-0.907,0.281-1.87-0.227-2.152-1.134 c-0.279-0.901,0.219-1.857,1.115-2.146l0.087-0.028l10.674-3.437l0.069-0.022c0.937-0.302,1.942,0.213,2.244,1.151 c0.302,0.938-0.213,1.942-1.151,2.244C1912.985,435.801,1912.973,435.805,1912.97,435.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1890.985,441.844c-3.751,0.727-7.552,1.264-11.381,1.537c-0.879,0.063-1.642-0.599-1.704-1.478 c-0.062-0.873,0.591-1.631,1.46-1.703c3.68-0.303,7.344-0.862,10.977-1.608c0.897-0.184,1.773,0.393,1.958,1.29 c0.184,0.897-0.394,1.773-1.291,1.957C1891.001,441.841,1890.988,441.843,1890.985,441.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1868.039,443.301c-3.874-0.425-7.671-1.335-11.318-2.628c-0.765-0.271-1.166-1.111-0.894-1.876 c0.269-0.76,1.101-1.159,1.862-0.899c3.463,1.185,7.048,1.999,10.667,2.355c0.842,0.083,1.458,0.832,1.375,1.675 c-0.083,0.842-0.832,1.458-1.675,1.375C1868.054,443.302,1868.042,443.301,1868.039,443.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1846.271,435.689c-3.297-2.011-6.392-4.356-9.198-7.019c-0.538-0.511-0.561-1.362-0.05-1.901 c0.507-0.534,1.352-0.559,1.891-0.059c2.687,2.494,5.654,4.691,8.808,6.568c0.668,0.397,0.887,1.261,0.49,1.928 c-0.397,0.668-1.261,0.888-1.928,0.49C1846.282,435.696,1846.273,435.69,1846.271,435.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1829.692,419.717c-2.057-3.297-3.655-6.922-4.518-10.755c-0.148-0.657,0.265-1.309,0.922-1.457 c0.652-0.147,1.3,0.261,1.454,0.909c0.832,3.515,2.348,6.866,4.309,9.934c0.381,0.596,0.207,1.389-0.389,1.77 c-0.596,0.381-1.389,0.207-1.77-0.389C1829.698,419.728,1829.693,419.719,1829.692,419.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1825.019,397.185c0.393-1.918,0.993-3.789,1.768-5.576c0.247-0.57,0.909-0.832,1.479-0.585 c0.566,0.245,0.828,0.901,0.59,1.468c-0.698,1.66-1.229,3.385-1.569,5.145c-0.121,0.627-0.728,1.037-1.355,0.915 c-0.627-0.121-1.037-0.728-0.916-1.355C1825.016,397.196,1825.018,397.186,1825.019,397.185z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1842.47,324.509 1820.729,364.877 1802.737,332.798  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1673.422,203.573l57.517,154.337c1.101,2.955,3.358,5.334,6.25,6.591 c2.892,1.257,6.171,1.282,9.083,0.07l152.781-63.586c1.749-0.728,2.882-2.445,2.864-4.339c-0.018-1.895-1.184-3.589-2.947-4.283 L1673.422,203.573z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1842.455,324.506 1673.422,203.573 1817.83,334.844 1812.278,346.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1803.184,340.863 1820.729,364.877 1817.83,334.844  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1259.237,438.02l-55.605,528.084l105.696,11.129l55.604-528.084 C1363.741,460.452,1258.047,449.323,1259.237,438.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120532255122179233990000015437103541503788730_",
    gradientUnits: "userSpaceOnUse",
    x1: 622.6413,
    y1: 3599.5991,
    x2: 339.1718,
    y2: 3603.4424,
    gradientTransform: "matrix(-0.1047 0.9945 -0.9945 -0.1047 4925.0781 510.9923)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120532255122179233990000015437103541503788730_)"
    },
    d: "M1230.081,968.889l48.371,5.093 c17.052,1.795,31.973-7.185,33.329-20.058l52.916-502.549c1.066-10.123,10.137-17.466,20.261-16.4 c3.076,0.324,5.307,3.08,4.983,6.156l-57.833,549.247c-1.327,12.596-23.236,30.509-47.665,27.937l-67.556-7.113 c-23.033-2.425-39.661-23.806-38.41-35.682l57.666-547.661c0.492-4.672,4.678-8.06,9.349-7.568 c8.528,0.898,14.712,8.539,13.815,17.066l-53.572,508.779C1204.573,957.164,1215.474,967.351,1230.081,968.889z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1289.184,962.554c-0.078,0-0.158-0.004-0.237-0.012 c-1.236-0.131-2.133-1.238-2.003-2.473l52.137-495.151c0.13-1.236,1.242-2.134,2.473-2.003 c1.236,0.131,2.133,1.238,2.003,2.473l-52.137,495.151C1291.298,961.694,1290.322,962.554,1289.184,962.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1273.495,960.902c-0.078,0-0.158-0.004-0.237-0.012 c-1.236-0.131-2.133-1.238-2.003-2.473l52.137-495.151c0.13-1.235,1.235-2.126,2.473-2.003 c1.236,0.131,2.133,1.238,2.003,2.473l-52.137,495.151C1275.609,960.043,1274.633,960.902,1273.495,960.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1257.807,959.25c-0.078,0-0.158-0.004-0.237-0.012 c-1.236-0.131-2.133-1.238-2.003-2.473l52.138-495.151c0.131-1.236,1.245-2.134,2.473-2.003 c1.236,0.131,2.133,1.238,2.003,2.473l-52.138,495.151C1259.921,958.39,1258.944,959.25,1257.807,959.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1242.119,957.598c-0.078,0-0.158-0.004-0.237-0.012 c-1.236-0.131-2.133-1.238-2.003-2.473l52.137-495.151c0.13-1.235,1.239-2.125,2.473-2.003 c1.236,0.131,2.133,1.238,2.003,2.473l-52.137,495.151C1244.233,956.739,1243.256,957.598,1242.119,957.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1226.43,955.946c-0.078,0-0.158-0.004-0.237-0.012 c-1.236-0.131-2.133-1.238-2.003-2.473l52.137-495.151c0.13-1.236,1.233-2.133,2.473-2.003 c1.236,0.131,2.133,1.238,2.003,2.473l-52.137,495.151C1228.544,955.086,1227.567,955.946,1226.43,955.946z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010308237323693579760000013958547307131500966_",
    gradientUnits: "userSpaceOnUse",
    x1: 7939.5186,
    y1: 2082.2744,
    x2: 7848.7495,
    y2: 2772.7656,
    gradientTransform: "matrix(-0.1047 0.9945 0.9945 0.1047 1546.5676 -7208.2783)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010308237323693579760000013958547307131500966_)"
    },
    d: "M1534.658,1363.138l86.736-823.738 c2.674-25.391-15.743-48.143-41.134-50.816l-129.082-13.592c-25.391-2.674-48.143,15.743-50.816,41.134l-86.736,823.738 c-2.674,25.391,15.743,48.143,41.134,50.816l129.082,13.592C1509.234,1406.946,1531.985,1388.529,1534.658,1363.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1579.337,694.892l9.87-93.739c0.402-3.82-2.369-7.243-6.189-7.645l-156.392-16.468 c-3.82-0.402-7.243,2.369-7.645,6.189l-9.87,93.739c-0.402,3.82,2.369,7.243,6.189,7.645l156.392,16.468 C1575.512,701.483,1578.934,698.712,1579.337,694.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1573.285,752.368l3.065-29.11c0.327-3.107-1.926-5.891-5.033-6.218L1412.342,700.3 c-3.107-0.327-5.891,1.926-6.218,5.033l-3.065,29.11c-0.327,3.107,1.926,5.891,5.034,6.218l158.975,16.739 C1570.174,757.728,1572.958,755.475,1573.285,752.368z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089568086019164557750000010929584336963293098_",
    gradientUnits: "userSpaceOnUse",
    x1: 967.7521,
    y1: 559.457,
    x2: 827.6005,
    y2: 989.051
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089568086019164557750000010929584336963293098_)"
    },
    d: "M1124.335,773.719 c0,16.966-1.855,33.402-5.434,49.306v0.066c-4.573,20.545-11.928,40.029-21.604,58.055c-0.066,0-0.066,0.066-0.066,0.066 c-20.877,38.703-52.753,70.645-91.389,91.588c-0.266,0.133-0.531,0.33-0.796,0.463c-11.2,6.032-22.996,11.135-35.256,15.243 c-0.065,0-0.132,0.066-0.198,0.066c-22.534,7.49-46.656,11.597-71.707,11.597c-66.537,0-126.381-28.696-167.801-74.423 c-36.383-40.161-58.65-93.444-58.65-152.028c0-10.14,0.662-20.147,1.921-29.889c10.471-79.394,62.097-145.799,132.677-177.079 c0.729-0.332,1.392-0.663,2.12-0.993c27.437-11.863,57.855-18.49,89.733-18.49c1.989,0,3.911,0,5.832,0.065 c0.729,0,1.458,0,2.12,0.068c51.825,3.181,93.444,23.791,108.024,31.942c2.452,1.392,4.109,2.387,4.97,2.916 c0.199,0.133,0.398,0.265,0.597,0.398h0.066C1082.518,622.884,1124.335,693.397,1124.335,773.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1019.428,582.656c-98.216,7.886-147.324,86.883-147.324,86.883s-2.319,6.362-6.825,11.598 c-0.066,0-0.066,0.066-0.133,0.066c-2.187,2.584-5.037,4.838-8.35,5.897c0,0.066-0.066,0.066-0.066,0.066 c-2.85,0.929-6.031,0.993-9.675-0.398c-10.405-6.495-18.158-19.086-23.991-33.665c-14.712-36.649-17.032-86.353-17.032-86.353 c0.729-0.332,1.392-0.663,2.12-0.993c33.003-15.707,65.941-20.014,95.565-18.426c0.729,0,1.458,0,2.12,0.068 c51.825,3.181,93.444,23.791,108.024,31.942c2.452,1.392,4.109,2.387,4.97,2.916 C1019.03,582.391,1019.229,582.524,1019.428,582.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M815.044,677.625v36.45c-0.332,0.066-0.662,0.133-0.994,0.199 c-67.333,12.856-82.244,188.61-83.967,211.474c-36.383-40.161-58.65-93.444-58.65-152.028c0-10.14,0.662-20.147,1.921-29.889 c18.358-72.302,99.408-71.043,129.959-67.796C810.604,676.764,815.044,677.625,815.044,677.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1118.901,823.026c0.066,0.066,0,0.066,0,0.066c-4.573,20.545-11.928,40.029-21.604,58.055 c-0.066,0-0.066,0.066-0.066,0.066c-22.997,31.148-57.459,69.851-91.389,91.588c-0.266,0.133-0.531,0.33-0.796,0.463 c-11.995,7.622-23.923,13.057-35.256,15.243c-0.065,0-0.132,0.066-0.198,0.066c-0.133,0-0.332,0.066-0.464,0.066 c-46.656-7.621-104.379-197.556-123.531-265.221c-4.242-14.779-6.561-23.724-6.561-23.724s0,0,17.695-12.526 c2.451-1.723,5.236-3.711,8.417-5.964c0.066,0,0.066-0.066,0.133-0.066c3.644,0.529,7.289,1.06,10.868,1.59 C1048.255,709.237,1102.797,793.004,1118.901,823.026z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031196022955662161270000006505774377498527642_",
    gradientUnits: "userSpaceOnUse",
    x1: 801.7895,
    y1: 686.7372,
    x2: 876.3457,
    y2: 686.7372
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000031196022955662161270000006505774377498527642_)"
    },
    cx: 839.068,
    cy: 686.737,
    r: 37.278
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1319.777,608.659L1319.777,608.659c-71.702,55.593-171.25,58.01-245.566,5.963l-8.515-5.963 c-4.224,5.068-85.665,89.819-131.687,194.339c-2.544,5.778-2.014,12.437,1.311,17.803c8.034,12.963,24.83,36.57,45.614,46.151 c7.636,3.52,16.681,1.548,22.271-4.733c15.37-17.273,49.258-56.072,65.097-79.83c0,0-27.643,152.561-35.1,214.998 c-2.234,18.707,10.778,35.807,29.385,38.759c90.792,14.403,178.374,16.484,261.384,1.014 c18.157-3.384,30.575-20.248,28.439-38.593c-7.245-62.22-35.239-216.178-35.239-216.178 c15.839,23.758,49.727,62.557,65.097,79.83c5.589,6.281,14.635,8.252,22.271,4.733c20.784-9.581,37.581-33.188,45.615-46.151 c3.326-5.366,3.856-12.026,1.311-17.803C1405.442,698.478,1324.001,613.727,1319.777,608.659z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173841124718579720370000016873313828397932440_",
    gradientUnits: "userSpaceOnUse",
    x1: 1031.1616,
    y1: 652.8784,
    x2: 1360.1793,
    y2: 652.8784
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173841124718579720370000016873313828397932440_)"
    },
    d: "M1360.179,655.987 c-21.951-27.668-38.556-45.113-40.402-47.329l0,0c-71.702,55.593-171.25,58.01-245.566,5.963l-8.515-5.963 c-1.678,2.013-15.547,16.611-34.535,40.018C1070.136,677.291,1182.374,737.628,1360.179,655.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1349.277,974.65c-3.552-25.104-8.625-56.596-13.694-86.787 c-117.912,18.656-213.275,15.202-286.275,3.701c-5.053,30.225-10.053,61.412-13.486,85.878 C1112.864,991.417,1217.272,996.828,1349.277,974.65z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093866821581772195930000005946200549005480354_",
    gradientUnits: "userSpaceOnUse",
    x1: 938.0296,
    y1: 773.793,
    x2: 1441.7953,
    y2: 773.793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093866821581772195930000005946200549005480354_)"
    },
    d: "M1323.15,815.834 c-3.577-20.237-5.979-33.445-5.979-33.445c5.689,8.534,13.71,19.009,22.362,29.729c32.318-7.623,66.412-17.422,102.262-29.783 c-12.379-25.031-26.447-48.622-40.528-69.872c-223.107,87.967-365.868,36.863-421.717,7.119 c-14.695,22.74-29.174,47.924-41.521,74.535c21.261,9.605,53.958,21.672,97.877,30.224 c12.264-14.711,24.547-30.178,32.396-41.952c0,0-3.423,18.892-8.185,46.101 C1126.497,838.381,1214.373,839.482,1323.15,815.834z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098900503432645313650000011560620650581277574_",
    gradientUnits: "userSpaceOnUse",
    x1: 1203.5764,
    y1: -101.4067,
    x2: 1199.5764,
    y2: 198.593
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098900503432645313650000011560620650581277574_)"
    },
    d: "M1063.598,626.448 c-4.796,0-9.203-3.164-10.569-8.007c-1.648-5.841,1.752-11.91,7.591-13.557c4.465-1.259,111.131-30.59,265.479-8.543 c6.006,0.858,10.181,6.424,9.323,12.431c-0.86,6.006-6.418,10.176-12.432,9.323c-149.78-21.401-255.354,7.642-256.404,7.937 C1065.588,626.314,1064.585,626.448,1063.598,626.448z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021829315263479195190000008415078927352618162_",
    gradientUnits: "userSpaceOnUse",
    x1: 1191.0865,
    y1: -101.5724,
    x2: 1187.0865,
    y2: 198.4281
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021829315263479195190000008415078927352618162_)"
    },
    d: "M1178.386,610.197 c-5.873,0-10.743-4.645-10.971-10.565c-0.008-0.21-0.809-21.266-0.809-40.482c0-10.779,8.77-20.453,19.872-32.701 c22.697-25.039,30.022-37.501,16.624-49.868c-7.735-7.141-15.139-10.213-22.614-9.383 c-14.647,1.615-25.762,17.441-25.873,17.601c-3.445,4.974-10.278,6.246-15.264,2.822c-4.988-3.425-6.282-10.22-2.877-15.221 c0.671-0.987,16.73-24.198,41.428-27.024c14.054-1.599,27.539,3.46,40.103,15.059c31.564,29.133,2.26,61.458-15.246,80.773 c-5.343,5.894-13.391,14.772-14.179,18.158c0.005,18.74,0.785,39.216,0.793,39.422c0.233,6.064-4.493,11.168-10.557,11.401 C1178.673,610.194,1178.529,610.197,1178.386,610.197z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113346941085507603060000007801038901417707916_",
    gradientUnits: "userSpaceOnUse",
    x1: 1459.7253,
    y1: 1712.8153,
    x2: 1684.7494,
    y2: 802.493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113346941085507603060000007801038901417707916_)"
    },
    d: "M1503.265,828.625l-35.723,614.568 l225.651-24.799c10.401-1.132,18.397-9.358,18.779-19.814l20.815-569.955H1503.265z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030451968609130290010000001174005968809958036_",
    gradientUnits: "userSpaceOnUse",
    x1: 1075.9858,
    y1: 855.4683,
    x2: 1095.9863,
    y2: 1463.4685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030451968609130290010000001174005968809958036_)"
    },
    d: "M648.693,868.448l25.734,530.593 c0.898,18.605,16.175,33.301,34.801,33.55l758.284,10.114c9.43,0.126,18.296-3.532,25.009-10.156 c6.713-6.624,10.27-15.662,10.27-25.094V827.648L648.693,868.448z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035495825877059988130000008006512610204632479_",
    gradientUnits: "userSpaceOnUse",
    x1: 1565.8707,
    y1: 681.2169,
    x2: 1665.8705,
    y2: 925.216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035495825877059988130000008006512610204632479_)"
    },
    d: "M1790.914,928.101l-44.627-99.476 h-243.875l90.449,139.212c4.382,6.768,12.242,10.198,20.245,9.22l161.123-19.815c6.637-0.811,12.495-4.541,15.786-10.361 C1793.306,941.06,1793.639,934.207,1790.914,928.101z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023250203639586753110000007809088098604011931_",
    gradientUnits: "userSpaceOnUse",
    x1: 1302.2483,
    y1: 589.8244,
    x2: 1070.2485,
    y2: 853.8242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023250203639586753110000007809088098604011931_)"
    },
    d: "M631.522,828.625L565.521,947.56 c-3.575,6.469-3.5,14.094,0.198,20.493c3.698,6.399,10.478,10.271,17.868,10.403l814.991,14.496 c7.815,0.14,15.065-3.6,18.835-10.446l84.999-153.881H631.522z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M1147.108,1233.79c-3.579-16.137-17.889-27.131-34.417-27.131H1002.97 c-19.47,0-35.727,14.806-35.727,34.276v195.985l225.257,2.363L1147.108,1233.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1065.869,1279.137c-0.362-5.602-5.012-9.473-10.626-9.473h-5.837 c-2.915,0-5.702,0.706-7.711,2.817c-2.01,2.111-3.067,4.709-2.924,7.62l7.698,156.733l29.628,0.391L1065.869,1279.137z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004545096539573111770000002222540503825047446_",
    gradientUnits: "userSpaceOnUse",
    x1: 828.4876,
    y1: 391.049,
    x2: 828.4876,
    y2: 918.9436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004545096539573111770000002222540503825047446_)"
    },
    d: "M784.971,1079.143 c8.178-1.314,18.838-2.044,30.081-2.044c18.692,0,30.813,3.358,40.305,10.514c10.221,7.594,16.647,19.714,16.647,37.091 c0,18.838-6.864,31.835-16.356,39.865c-10.367,8.616-26.139,12.705-45.414,12.705c-11.537,0-19.715-0.73-25.263-1.46V1079.143z  M807.313,1159.459c1.899,0.438,4.965,0.438,7.74,0.438c20.153,0.145,33.295-10.952,33.295-34.463 c0.146-20.444-11.828-31.25-30.958-31.25c-4.965,0-8.178,0.437-10.077,0.876V1159.459z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178194500714889850120000011480591401795638926_",
    gradientUnits: "userSpaceOnUse",
    x1: 929.3859,
    y1: 391.0485,
    x2: 929.3859,
    y2: 918.9428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178194500714889850120000011480591401795638926_)"
    },
    d: "M976.699,1126.018 c0,32.273-19.567,51.84-48.335,51.84c-29.205,0-46.291-22.05-46.291-50.088c0-29.498,18.838-51.548,47.897-51.548 C960.198,1076.223,976.699,1098.858,976.699,1126.018z M905.583,1127.332c0,19.276,9.053,32.857,23.948,32.857 c15.041,0,23.657-14.311,23.657-33.44c0-17.67-8.47-32.856-23.803-32.856C914.345,1093.892,905.583,1108.203,905.583,1127.332z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173854568871603785870000010399521521915190677_",
    gradientUnits: "userSpaceOnUse",
    x1: 1032.0359,
    y1: 391.0481,
    x2: 1032.0359,
    y2: 918.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173854568871603785870000010399521521915190677_)"
    },
    d: "M991.294,1176.252v-98.423h25.993 l20.444,36.069c5.841,10.368,11.683,22.634,16.063,33.732h0.438c-1.46-12.996-1.898-26.285-1.898-41.033v-28.768h20.443v98.423 h-23.364l-21.029-37.968c-5.841-10.514-12.266-23.219-17.085-34.754l-0.439,0.146c0.585,12.996,0.877,26.869,0.877,42.932 v29.644H991.294z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109000896019264289750000005298168678704878237_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.7928,
    y1: 391.0481,
    x2: 1129.7928,
    y2: 918.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109000896019264289750000005298168678704878237_)"
    },
    d: "M1114.971,1150.989l-7.009,25.263 h-23.073l30.082-98.423h29.205l30.521,98.423h-23.949l-7.593-25.263H1114.971z M1139.942,1134.342l-6.133-20.883 c-1.752-5.841-3.505-13.142-4.965-18.983h-0.292c-1.46,5.841-2.92,13.288-4.527,18.983l-5.841,20.883H1139.942z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101099662668433085900000017180265697699107483_",
    gradientUnits: "userSpaceOnUse",
    x1: 1206.0869,
    y1: 391.0481,
    x2: 1206.0869,
    y2: 918.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101099662668433085900000017180265697699107483_)"
    },
    d: "M1194.697,1096.52h-26.431v-18.692 h75.642v18.692h-26.869v79.732h-22.342V1096.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103230261256579875490000008469240384608807053_",
    gradientUnits: "userSpaceOnUse",
    x1: 1287.1255,
    y1: 391.0481,
    x2: 1287.1255,
    y2: 918.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103230261256579875490000008469240384608807053_)"
    },
    d: "M1314.286,1134.634h-36.215v23.365 h40.451v18.253h-62.793v-98.423h60.748v18.253h-38.406v20.444h36.215V1134.634z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067934724220982839350000002667459943495175848_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.8417,
    y1: 1124.556,
    x2: 157.6422,
    y2: 1124.556,
    gradientTransform: "matrix(1 0 0 1 395.7825 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067934724220982839350000002667459943495175848_)"
    },
    d: "M514.508,1093.22 c-6.237,6.658-15.421,12.411-21.884,15.998c9.651,11.93,22.711,23.877,39.999,35.57l4.948,11.103l15.853-19 C553.425,1136.891,524.978,1122.735,514.508,1093.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050657298909607355150000005222625723399097751_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.4945,
    y1: 1133.8671,
    x2: 186.9947,
    y2: 1306.3584,
    gradientTransform: "matrix(1 0 0 1 395.7825 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050657298909607355150000005222625723399097751_)"
    },
    d: "M599.349,1453.595 c0.005-0.339-0.017-0.683-0.104-1.03c-5.135-20.357-30.621-33.037-30.621-33.037l-10.099,0.792 c-5.807,17.943-5.06,28.948-4.128,33.849c0.026,0.137,0.068,0.268,0.104,0.401C562.831,1455.313,579.978,1455.8,599.349,1453.595 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159448413375108720930000000150427817456020367_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.1419,
    y1: 1162.7217,
    x2: 181.1419,
    y2: 1420.7107,
    gradientTransform: "matrix(1 0 0 1 395.7825 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159448413375108720930000000150427817456020367_)"
    },
    d: "M554.5,1454.569 c0.45,1.636,1.658,2.911,3.205,3.236c11.851,2.492,30.686,0.487,38.594-0.547c1.745-0.228,3.02-1.842,3.049-3.663 C579.978,1455.8,562.831,1455.313,554.5,1454.569z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156589614565802183410000005247912621188223411_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.6542,
    y1: 1385.4581,
    x2: 161.9455,
    y2: 1461.4618,
    gradientTransform: "matrix(1 0 0 1 395.7825 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156589614565802183410000005247912621188223411_)"
    },
    d: "M554.463,1405.277l4.277,20.591 c0.314,1.508,1.473,2.638,2.877,2.77c1.719,0.162,4.166,0.256,6.627-0.105c2.206-0.324,3.743-2.567,3.352-4.973l-2.973-18.283 H554.463z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088122319211020282560000005479873398823033268_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.3528,
    y1: 1162.7264,
    x2: 260.3528,
    y2: 1420.7112,
    gradientTransform: "matrix(1 0 0 1 395.7825 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088122319211020282560000005479873398823033268_)"
    },
    d: "M643.086,1454.362 c-11.154-0.313-16.923-1.626-19.905-2.845c-0.007,1.109-0.001,2.238,0.035,3.407c0.038,1.249,0.963,2.246,2.101,2.239 l61.241-0.395c1.954-0.013,3.096-2.279,2.25-4.071C680.779,1453.361,660.328,1454.845,643.086,1454.362z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006701784612681161080000013658926299281234612_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.8675,
    y1: 1137.3176,
    x2: 266.3677,
    y2: 1309.8092,
    gradientTransform: "matrix(1 0 0 1 395.7825 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006701784612681161080000013658926299281234612_)"
    },
    d: "M688.809,1452.698 c-0.074-0.156-0.138-0.315-0.243-0.462c-5.408-7.557-19.183-22.605-46.403-29.132l-13.058-0.413c0,0-5.814,10.106-5.924,28.826 c2.982,1.219,8.751,2.532,19.905,2.845C660.328,1454.845,680.779,1453.361,688.809,1452.698z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101062711602529402780000002204914369607372935_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.5926,
    y1: 1393.5868,
    x2: 232.884,
    y2: 1469.5894,
    gradientTransform: "matrix(1 0 0 1 395.7825 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101062711602529402780000002204914369607372935_)"
    },
    d: "M626.684,1402.902 c0.145,0.973,1.935,15.767,2.628,21.502c0.164,1.363,1.152,2.418,2.396,2.566c2.224,0.266,5.822,0.508,8.969-0.138 c1.698-0.348,2.927-1.979,2.927-3.876v-23.221L626.684,1402.902z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044882638488405718020000006009816674197202064_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.8204,
    y1: 1397.1106,
    x2: -159.714,
    y2: 1829.3195,
    gradientTransform: "matrix(1 0 0 1 395.7825 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044882638488405718020000006009816674197202064_)"
    },
    d: "M616.208,1132.932 c0,0,31.495,119.692,30.925,270.312c-0.011,2.746-1.938,5.116-4.626,5.682c-3.96,0.834-9.781,1.824-14.6,1.689 c-2.572-0.072-4.723-1.98-5.156-4.517c-4.416-25.898-29.759-171.79-44.198-195.476c0,0-9.5,129.939-6.463,197.352 c0.075,1.676-1.152,3.13-2.819,3.323c-2.529,0.292-6.573,0.514-11.721-0.033c-1.954-0.208-3.531-1.685-3.81-3.63 c-3.146-21.918-21.25-152.38-20.481-246.359c0.044-5.3,14.016-28.344,14.016-28.344H616.208z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155137827180629526590000005283746199458629544_",
    gradientUnits: "userSpaceOnUse",
    x1: -593.5987,
    y1: 961.0875,
    x2: -638.3267,
    y2: 1399.0459,
    gradientTransform: "matrix(1 0 0 1 1163.5511 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155137827180629526590000005283746199458629544_)"
    },
    d: "M660.01,988.076 c-5.112-6.407-9.59-13.275-13.335-20.352c-5.232-9.884-0.421,6.398-1.85-4.763c-39.176-28.271-98.168-13.961-120.987-11.087 c-7.482,0.943-14.325,4.631-19.255,10.337c-19.554,22.628-62.461,84.58-11.958,147.006c6.463-3.587,15.647-9.34,21.884-15.998 c-5.587-15.75-6.045-35.878,5.665-60.561c0.4,1.957,0.895,3.893,1.496,5.799c16.139,51.13,17,93.678,16.964,103.485 c-0.005,1.331,0.794,2.53,2.031,3.026c21.241,8.512,62.129,3.446,75.854,1.4c2.517-0.375,4.21-2.718,3.862-5.238 c-6.736-48.803,27.835-129.086,36.966-149.194C658.003,990.491,658.911,989.188,660.01,988.076z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066481114960562020720000010129445632188624276_",
    gradientUnits: "userSpaceOnUse",
    x1: 576.7775,
    y1: 877.3334,
    x2: 576.7775,
    y2: 991.3334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066481114960562020720000010129445632188624276_)"
    },
    d: "M560.55,910.781l-4.094,41.825 c0,0,23.529,7.087,40.642-4.988l-12.03-38.013L560.55,910.781z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018233942250217918050000003434782827092433024_",
    gradientUnits: "userSpaceOnUse",
    x1: 627.9282,
    y1: 821.9109,
    x2: 591.2616,
    y2: 883.9106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018233942250217918050000003434782827092433024_)"
    },
    d: "M587.852,863.11 c0.567,0.533,23.899,46.354,23.899,46.354l-26.446,12.767l-28.567-40.143C556.738,882.088,578.372,854.186,587.852,863.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063597095955270581970000009323050651126945210_",
    gradientUnits: "userSpaceOnUse",
    x1: -1463.6259,
    y1: -1011.1259,
    x2: -1393.1589,
    y2: -1011.1259,
    gradientTransform: "matrix(0.6854 -0.7281 0.7281 0.6854 2302.3018 544.7815)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063597095955270581970000009323050651126945210_)"
    },
    d: "M568.439,883.199 c-0.472,1.221-0.356,2.583,0.318,3.705l13.19,21.988c0.201,0.333,0.438,0.635,0.723,0.9c1.57,1.461,6.942,5.712,11.095-0.075 c3.54-4.932,6.861-9.417,10.42-11.267c2.078-1.08,4.636-0.218,5.691,1.873c2.173,4.307,6.382,13.087,9.027,21.413 c0.663,2.087-0.414,4.327-2.444,5.149c-5.355,2.17-15.939,6.093-25.331,7.389c-1.543,0.213-3.07-0.438-3.988-1.696 c-4.04-5.535-15.429-21.005-19.316-24.876c-3.611-3.598-10.276-2.241-13.279-1.378c-1.14,0.328-2.354,0.17-3.37-0.442 c-3.047-1.835-8.365-6.405-3.5-14.143c1.209-1.924,0.593-4.486-1.306-5.735c-3.402-2.238-7.093-6.438-3.576-13.24 c3.56-6.886,9.918-7.504,14.248-6.975c1.916,0.234,3.861-0.771,4.596-2.555c0.327-0.794,0.973-1.471,2.177-1.715 c2.269-0.46,3.759-2.536,3.314-4.808c-0.764-3.897-0.189-8.959,6.033-12.38c11.411-6.274,21.406,3.949,23.947,12.578 c2.542,8.63-10.216,14.728-18.242,15.746C572.972,873.403,569.74,879.836,568.439,883.199z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136372794363222626680000015596693908279476896_",
    gradientUnits: "userSpaceOnUse",
    x1: -1504.9729,
    y1: -968.0647,
    x2: -1457.6565,
    y2: -1016.61,
    gradientTransform: "matrix(0.6854 -0.7281 0.7281 0.6854 2302.3018 544.7815)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136372794363222626680000015596693908279476896_)"
    },
    d: "M572.778,915.777 c0,0-5.074-14.846-11.569-14.301c-6.495,0.545-11.607,7.015-3.558,14.289C567.664,924.811,572.778,915.777,572.778,915.777z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115477507582067568580000000251448445668308159_",
    gradientUnits: "userSpaceOnUse",
    x1: 554.5272,
    y1: 932.7725,
    x2: 531.1939,
    y2: 975.4391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115477507582067568580000000251448445668308159_)"
    },
    d: "M518.031,1028.836 c-8.561-23.429-5.455-51.72-5.423-52.003l2.359,0.269c-0.031,0.278-3.071,28.027,5.295,50.919L518.031,1028.836z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082348857852414197700000012988258069266714272_",
    gradientUnits: "userSpaceOnUse",
    x1: 622.9017,
    y1: 977.4122,
    x2: 588.4033,
    y2: 1109.4059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082348857852414197700000012988258069266714272_)"
    },
    d: "M577.397,1207.572 c-0.528,0-1.01-0.354-1.148-0.889c-2.612-10.073-22.169-21.143-22.366-21.254c-0.572-0.32-0.776-1.044-0.455-1.616 c0.321-0.572,1.041-0.777,1.617-0.455c0.841,0.471,20.638,11.678,23.503,22.729c0.164,0.635-0.217,1.283-0.852,1.447 C577.596,1207.56,577.495,1207.572,577.397,1207.572z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074420499525599425230000016919158467520139661_",
    gradientUnits: "userSpaceOnUse",
    x1: -491.6877,
    y1: 970.8107,
    x2: -539.5656,
    y2: 1439.6123,
    gradientTransform: "matrix(1 0 0 1 1163.5511 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074420499525599425230000016919158467520139661_)"
    },
    d: "M739.532,1001.23 c-44.309,6.648-73.188-21.309-94.708-38.268c-28.412-22.391-50.522-11.497-50.522-11.497l30.3,57.827 c45.249,42.663,91.642,33.189,120.89,19.363C745.943,1017.485,742.958,1008.138,739.532,1001.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182497741713420653900000012468339025097924517_",
    gradientUnits: "userSpaceOnUse",
    x1: -307.7781,
    y1: 397.0313,
    x2: -343.7781,
    y2: 649.0314,
    gradientTransform: "matrix(1 0 0 1 1163.5511 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182497741713420653900000012468339025097924517_)"
    },
    d: "M801.807,974.795l-14.694,7.907 c-17.622,10.729-33.391,16.399-47.582,18.528c3.426,6.908,6.411,16.255,5.96,27.425c18.619-8.8,30.291-19.363,30.291-19.363 C809.07,989.443,801.807,974.795,801.807,974.795z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085930919879546932240000007938182933202463163_",
    gradientUnits: "userSpaceOnUse",
    x1: -264.1577,
    y1: 403.2608,
    x2: -300.1577,
    y2: 655.2609,
    gradientTransform: "matrix(1 0 0 1 1163.5511 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085930919879546932240000007938182933202463163_)"
    },
    d: "M845.094,995.501 c-0.949-3.153-3.28-5.704-6.335-6.933l-29.821-11.992c0,0-0.45-3.824,6.301-6.423c6.751-2.599,5.173-10.16,5.173-10.16 s-9.223,4.207-22.726,10.88c-7.721,3.816-12.054,10.554-14.352,15.626l7.677,10.095c18.379,5.522,36.977,6.577,55.733,4.387 L845.094,995.501z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030460821658933202700000016785001976270106024_",
    gradientUnits: "userSpaceOnUse",
    x1: -94.5519,
    y1: 1062.8807,
    x2: -166.5375,
    y2: 1062.8807,
    gradientTransform: "matrix(-1 0 0 1 311.3 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030460821658933202700000016785001976270106024_)"
    },
    d: "M477.837,1048.134 c0,0-26.738,61.702-43.191,53.475c-16.454-8.227-28.794-76.099-28.794-76.099S457.27,1013.17,477.837,1048.134z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038384171629084228000000014618389425124961157_",
    gradientUnits: "userSpaceOnUse",
    x1: 1249.1724,
    y1: 1320.9753,
    x2: 1250.7115,
    y2: 1490.2712,
    gradientTransform: "matrix(1 0 0 1 -830.9982 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038384171629084228000000014618389425124961157_)"
    },
    d: "M384.744,1431.028 c0,0-2.235,12.654-3.331,25.18c-0.428,4.895,3.346,9.146,8.256,9.351c16.681,0.695,52.362,2.046,65.166,1.474 c1.924-0.086,3.183-2.057,2.471-3.847l0,0c-0.597-1.5-1.748-2.713-3.215-3.387l-58.939-27.088L384.744,1431.028z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111882021117938718520000016897868864337811860_",
    gradientUnits: "userSpaceOnUse",
    x1: 1213.9111,
    y1: 1430.9763,
    x2: 1233.0826,
    y2: 1430.9763,
    gradientTransform: "matrix(1 0 0 1 -830.9982 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111882021117938718520000016897868864337811860_)"
    },
    d: "M382.913,1423.594l1.796,15.136 c0,0,10.324,4.806,17.375-0.606l-4.276-16.868L382.913,1423.594z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145034079746646209900000009544815124828672147_",
    gradientUnits: "userSpaceOnUse",
    x1: 1192.2496,
    y1: 1503.9231,
    x2: 1205.3344,
    y2: 1152.8252,
    gradientTransform: "matrix(1 0 0 1 -830.9982 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145034079746646209900000009544815124828672147_)"
    },
    d: "M384.263,1139.036 c-0.776,3.953-4.164,197.245,16.498,283.866c0.337,1.413-0.379,2.87-1.725,3.42c-3.169,1.295-9.381,3.17-16.827,3.42 c-2.306,0.078-4.373-1.421-5.023-3.635c-5.906-20.097-34.207-120.791-37.899-216.981c-4.125-107.482,0-3.659,0-3.659 l2.419-66.439L384.263,1139.036z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088106930391406181640000008128650502220461714_",
    gradientUnits: "userSpaceOnUse",
    x1: 1154.9304,
    y1: 1321.8336,
    x2: 1156.4696,
    y2: 1491.1278,
    gradientTransform: "matrix(1 0 0 1 -830.9982 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088106930391406181640000008128650502220461714_)"
    },
    d: "M316.945,1437.63 c0,0-3.558,6.389-7.003,23.363c-0.622,3.066,1.52,6,4.633,6.306c5.508,0.542,13.988,1.238,20.78,1.191 c3.131-0.021,5.575-2.748,5.198-5.856c-0.752-6.196-3.096-16.361-10.337-24.285L316.945,1437.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021824428170263117700000001052865835337650111_",
    gradientUnits: "userSpaceOnUse",
    x1: 1144.8177,
    y1: 1429.9933,
    x2: 1161.3707,
    y2: 1429.9933,
    gradientTransform: "matrix(1 0 0 1 -830.9982 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021824428170263117700000001052865835337650111_)"
    },
    d: "M313.82,1418.162l4.196,22.889 c0,0,4.149,3.086,12.357,0.849l-2.003-24.627L313.82,1418.162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183958563424380371240000018191399229893497766_",
    gradientUnits: "userSpaceOnUse",
    x1: 1159.8893,
    y1: 1502.717,
    x2: 1172.9739,
    y2: 1151.6201,
    gradientTransform: "matrix(1 0 0 1 -830.9982 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183958563424380371240000018191399229893497766_)"
    },
    d: "M302.484,1144.967 c-16.899,101.983,3.665,252.059,10.601,281.432c0.425,1.798,1.876,3.176,3.699,3.478c3.096,0.513,8.192,0.932,13.217-0.527 c1.731-0.503,2.948-2.064,3.018-3.866c0.93-23.748-0.745-169.535,15.001-227.151c0.798-2.92,2.581-5.466,5.048-7.22 l30.561-21.726l2.343-35.118L302.484,1144.967z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172425192557032821230000011075493590476829602_",
    gradientUnits: "userSpaceOnUse",
    x1: -60.2002,
    y1: 984.4739,
    x2: 39.3966,
    y2: 1246.4907,
    gradientTransform: "matrix(-1 0 0 1 311.3 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172425192557032821230000011075493590476829602_)"
    },
    d: "M412.022,955.581 c-61.702-6.17-108.379,9.445-108.379,9.445c-15.095,88.079-2.64,189.672-2.64,189.672c39.205,10.281,83.431-6.286,83.431-6.286 c6.516-36.815,36.919-140.424,36.919-140.424C446.096,1004.917,427.566,957.136,412.022,955.581z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130636299357426543530000016783711521272112831_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3635,
    y1: 961.0724,
    x2: 100.96,
    y2: 1223.0886,
    gradientTransform: "matrix(-1 0 0 1 311.3 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130636299357426543530000016783711521272112831_)"
    },
    d: "M323.067,1014.062l-19.424-49.036 c0,0-47.302,32.139-55.081,72.889c8.938,0.658,25.201,2.983,41.12,11.021C293.181,1029.695,323.067,1014.062,323.067,1014.062z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062875895564414943810000016657700154250441662_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.1997,
    y1: 1031.1268,
    x2: 279.5329,
    y2: 1089.1268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062875895564414943810000016657700154250441662_)"
    },
    d: "M368.516,1060.203 c0,0-53.108,30.014-71.027,4.386c-3.72-5.322-8.323-12.391-7.406-17.433c-15.919-8.038-32.041-11.122-40.979-11.781 c-2.345,12.285,2.466,27.891,9.685,41.096c31.388,57.419,116.756-3.173,116.756-3.173L368.516,1060.203z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121257531779865702570000006770636725725946499_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.2172,
    y1: 842.4205,
    x2: 465.2173,
    y2: 921.4205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121257531779865702570000006770636725725946499_)"
    },
    d: "M362.135,1098.174l28.985-101.22 c0.329-1.149,1.309-1.987,2.496-2.126c5.252-0.612,20.468-2.333,38.037-3.819c21.163-1.79,45.739-3.241,60.425-2.007 c2.088,0.175,3.349,2.384,2.421,4.262c-8.351,16.896-42.704,85.624-59.906,108.138c-0.57,0.746-1.451,1.182-2.389,1.173 l-67.249-0.626C362.998,1101.932,361.596,1100.055,362.135,1098.174z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052792876808444998330000005683903923729312923_",
    gradientUnits: "userSpaceOnUse",
    x1: 1286.7123,
    y1: 936.6692,
    x2: 1272.1974,
    y2: 1000.4083,
    gradientTransform: "matrix(1 0 0 1 -830.9982 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052792876808444998330000005683903923729312923_)"
    },
    d: "M434.66,982.234l21.014-3.501 c1.119-0.186,2.036,0.883,1.68,1.96l-2.08,6.304c-0.181,0.549-0.66,0.946-1.233,1.022l-20.222,2.701 c-1.046,0.139-1.909-0.811-1.668-1.839l1.288-5.503C433.578,982.786,434.059,982.335,434.66,982.234z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176010669577234939780000004631834538671032492_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.3181,
    y1: 962.6484,
    x2: 415.3184,
    y2: 1047.3147
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176010669577234939780000004631834538671032492_)"
    },
    d: "M418.925,1000.025l1.731-9.017 c0.174-0.905,0.92-1.588,1.837-1.681l42.443-4.307c1.429-0.145,2.573,1.164,2.238,2.56l-2.699,11.237 c-0.216,0.899-0.999,1.548-1.922,1.594l-41.476,2.088C419.727,1002.567,418.67,1001.352,418.925,1000.025z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137828124944780832540000004301099466599879082_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.249,
    y1: 941.8976,
    x2: 420.2491,
    y2: 995.8976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137828124944780832540000004301099466599879082_)"
    },
    d: "M369.138,1073.719 c0,0-4.037-16.602-2.409-22.492c1.629-5.89,4.784-13.463,15.302-11.781c10.518,1.683,22.926,6.114,22.926,6.114 s-0.627,7.672-8.621,5.197l4.957,3.836c0,0-0.709,6.143-7.461,2.861l4.611,5.087c0,0-2.9,5.046-7.867,1.81 C385.608,1061.114,383.226,1075.719,369.138,1073.719z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108307124589886636530000011870650513620285116_",
    gradientUnits: "userSpaceOnUse",
    x1: -330.8388,
    y1: 587.5621,
    x2: -292.2223,
    y2: 587.5621,
    gradientTransform: "matrix(-0.8472 -0.5312 -0.5312 0.8472 520.2164 362.4392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108307124589886636530000011870650513620285116_)"
    },
    d: "M476.905,1049.018 c0,0,12.24-11.921,13.989-17.776c1.749-5.856,3.098-13.948-6.707-18.11c-9.805-4.161-22.671-6.998-22.671-6.998 s-3.544,6.833,4.543,8.982l-6.237,0.617c0,0-2.663,5.581,4.801,6.387l-6.608,1.861c0,0-0.224,5.815,5.704,5.712 C469.647,1029.589,463.907,1043.228,476.905,1049.018z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010299924366670338070000002420265524556173479_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.326,
    y1: 859.8961,
    x2: 358.8276,
    y2: 1009.8887
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010299924366670338070000002420265524556173479_)"
    },
    d: "M365.035,914.447l-16.113,46.599 c-0.267,0.771,0.05,1.627,0.765,2.022c4.393,2.428,20.217,9.448,39.287-2.643c1.987-1.259,3.339-3.314,3.641-5.646l5.218-40.331 H365.035z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090258454370525570590000012355704673096433578_",
    gradientUnits: "userSpaceOnUse",
    x1: -2545.2605,
    y1: 1811.8055,
    x2: -2588.5938,
    y2: 1756.4722,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 4824.2422 -1476.3188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090258454370525570590000012355704673096433578_)"
    },
    d: "M400.096,871.295 c0,0,17.694,33.307,15.426,46.761c-2.268,13.454-24.198,12.489-43.346,1.561l-13.381-35.964L400.096,871.295z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065070133946381248120000001240654590024369818_",
    gradientUnits: "userSpaceOnUse",
    x1: -4899.0767,
    y1: -1265.1221,
    x2: -4883.7583,
    y2: -1177.7507,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 4824.2422 -1476.3188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065070133946381248120000001240654590024369818_)"
    },
    d: "M373.022,901.956 c0.778-0.345,1.065-1.297,0.599-2.009c-1.418-2.166-4.075-6.584-4.923-10.452c0,0-3.181-2.037,8.096-4.736 c11.277-2.699,28.094-6.889,31.628-16.487c3.446-9.359-5.608-32.893-20.055-14.141c-0.549,0.714-1.626,0.729-2.175,0.015 c-2.368-3.082-8.595-9.48-17.238-5.602c-8.09,3.63-9,9.557-8.889,12.545c0.033,0.879-0.753,1.562-1.617,1.397 c-4.09-0.78-13.904-1.45-18.485,8.618c-3.773,8.293-1.321,12.987,0.913,15.283c0.724,0.744,0.407,1.969-0.585,2.273 c-2.688,0.823-6.159,3.102-5.811,9.399c0.48,8.706,10.214,7.939,12.985,7.542c0.454-0.065,0.912,0.091,1.219,0.431 c2.376,2.63,13.082,13.795,24.669,15.141c1.003,0.116,1.781-0.875,1.452-1.829l-5.015-14.577 c-0.233-0.677,0.091-1.42,0.746-1.71L373.022,901.956z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117649649590168073090000001499852238539227537_",
    gradientUnits: "userSpaceOnUse",
    x1: -2553.9753,
    y1: 1818.6283,
    x2: -2597.3086,
    y2: 1763.295,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 4824.2422 -1476.3188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117649649590168073090000001499852238539227537_)"
    },
    d: "M375.038,904.025 c0,0-12.598-8.644-13.519-1.365c-0.921,7.279,11.345,10.544,17.42,7.83L375.038,904.025z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121277988319754874680000002948425137666684557_",
    gradientUnits: "userSpaceOnUse",
    x1: 1869.8755,
    y1: 856.0698,
    x2: 1944.2019,
    y2: 769.7981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000121277988319754874680000002948425137666684557_)"
    },
    cx: 1945.703,
    cy: 768.056,
    r: 55.413
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120559598620711417390000016243076104540276664_",
    gradientUnits: "userSpaceOnUse",
    x1: 1986.2012,
    y1: 706.8747,
    x2: 1766.4159,
    y2: 1038.9075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000120559598620711417390000016243076104540276664_)"
    },
    cx: 1945.703,
    cy: 768.056,
    r: 53.571
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.71,
      fill: "#FFFFFF"
    },
    d: "M1901.527,748.052c-0.341,0-0.687-0.077-1.012-0.242 c-1.11-0.559-1.555-1.913-0.994-3.023c8.852-17.539,26.549-28.434,46.183-28.434c3.135,0,6.272,0.282,9.324,0.838 c1.223,0.223,2.034,1.395,1.811,2.617c-0.222,1.224-1.398,2.027-2.617,1.811c-2.787-0.509-5.653-0.766-8.517-0.766 c-17.926,0-34.083,9.948-42.166,25.962C1903.142,747.601,1902.35,748.052,1901.527,748.052z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1574 -0.9875 0.9875 0.1574 880.8428 2570.7759)",
    style: {
      opacity: 0.71,
      fill: "#FFFFFF"
    },
    cx: 1946.87,
    cy: 769.223,
    rx: 45.341,
    ry: 45.341
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012438429068257648040000016099931600582049967_",
    gradientUnits: "userSpaceOnUse",
    x1: 1979.6448,
    y1: 716.3885,
    x2: 1862.6138,
    y2: 912.8641
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012438429068257648040000016099931600582049967_)"
    },
    d: "M1942.421,802.93v-4.933 c-5.142-0.206-10.229-1.42-13.841-3.001c-1.29-0.565-1.948-2.012-1.577-3.371l1.253-4.595c0.46-1.686,2.293-2.557,3.904-1.882 c3.584,1.503,8.008,2.691,12.78,2.691c4.953,0,8.647-1.679,8.647-5.121c0-3.106-2.854-4.953-9.738-6.799 c-9.822-2.687-16.874-6.968-16.874-15.615c0-7.807,5.709-13.768,15.615-15.362v-4.933c0-1.587,1.287-2.874,2.874-2.874h2.898 c1.587,0,2.874,1.287,2.874,2.874v4.429c4.758,0.191,8.222,1.004,10.971,1.97c1.408,0.495,2.178,2.012,1.787,3.453 l-1.152,4.25c-0.444,1.639-2.196,2.536-3.784,1.936c-2.531-0.957-6.109-1.954-10.76-1.954c-5.877,0-7.555,2.435-7.555,4.617 c0,2.686,3.526,4.533,11.165,6.884c10.914,3.274,15.447,7.807,15.447,15.95c0,7.472-5.541,14.188-16.286,15.867v5.521 c0,1.588-1.287,2.874-2.874,2.874h-2.898C1943.708,805.804,1942.421,804.517,1942.421,802.93z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027585995352254720970000009025422747390664334_",
    gradientUnits: "userSpaceOnUse",
    x1: 1698.8027,
    y1: 979.3406,
    x2: 1806.0017,
    y2: 854.9133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000027585995352254720970000009025422747390664334_)"
    },
    cx: 1808.167,
    cy: 852.4,
    r: 79.921
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008126659590944782760000009657278036640368828_",
    gradientUnits: "userSpaceOnUse",
    x1: 1866.5762,
    y1: 764.1605,
    x2: 1549.5861,
    y2: 1243.0422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000008126659590944782760000009657278036640368828_)"
    },
    cx: 1808.167,
    cy: 852.4,
    r: 77.263
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.71,
      fill: "#FFFFFF"
    },
    d: "M1744.455,822.555c-0.341,0-0.687-0.077-1.012-0.242 c-1.11-0.559-1.555-1.913-0.995-3.023c12.598-24.959,37.78-40.464,65.719-40.464c4.455,0,8.921,0.402,13.271,1.194 c1.223,0.223,2.034,1.394,1.811,2.617s-1.394,2.03-2.617,1.811c-4.085-0.745-8.278-1.122-12.464-1.122 c-26.23,0-49.873,14.557-61.701,37.992C1746.07,822.104,1745.278,822.555,1744.455,822.555z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2347 -0.9721 0.9721 0.2347 554.8451 2412.9224)",
    style: {
      opacity: 0.71,
      fill: "#FFFFFF"
    },
    cx: 1809.851,
    cy: 854.083,
    rx: 65.394,
    ry: 65.394
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068676898960279885260000017543430024065513402_",
    gradientUnits: "userSpaceOnUse",
    x1: 1857.1201,
    y1: 777.8818,
    x2: 1688.3291,
    y2: 1061.2539
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068676898960279885260000017543430024065513402_)"
    },
    d: "M1803.433,902.698v-7.115 c-7.417-0.297-14.753-2.047-19.963-4.328c-1.861-0.814-2.809-2.903-2.275-4.862l1.808-6.627 c0.663-2.431,3.307-3.688,5.631-2.714c5.169,2.167,11.55,3.881,18.432,3.881c7.144,0,12.471-2.422,12.471-7.386 c0-4.479-4.116-7.143-14.045-9.806c-14.166-3.874-24.337-10.05-24.337-22.521c0-11.261,8.234-19.857,22.521-22.157v-7.115 c0-2.289,1.856-4.145,4.146-4.145h4.18c2.29,0,4.145,1.856,4.145,4.145v6.388c6.863,0.275,11.859,1.448,15.823,2.841 c2.031,0.714,3.141,2.902,2.578,4.98l-1.662,6.129c-0.641,2.363-3.167,3.658-5.457,2.792c-3.65-1.38-8.811-2.818-15.519-2.818 c-8.476,0-10.897,3.511-10.897,6.659c0,3.875,5.085,6.538,16.103,9.929c15.74,4.722,22.278,11.26,22.278,23.005 c0,10.776-7.991,20.462-23.489,22.884v7.962c0,2.289-1.856,4.145-4.145,4.145h-4.181 C1805.289,906.844,1803.433,904.988,1803.433,902.698z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143576654127667854220000012974928955818646673_",
    gradientUnits: "userSpaceOnUse",
    x1: 1857.0439,
    y1: 1076.995,
    x2: 1954.5947,
    y2: 963.7665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000143576654127667854220000012974928955818646673_)"
    },
    cx: 1956.565,
    cy: 961.479,
    r: 72.728
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168806642393370189150000009161325936259940795_",
    gradientUnits: "userSpaceOnUse",
    x1: 2009.7172,
    y1: 881.1818,
    x2: 1721.2571,
    y2: 1316.9629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000168806642393370189150000009161325936259940795_)"
    },
    cx: 1956.565,
    cy: 961.479,
    r: 70.309
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.71,
      fill: "#FFFFFF"
    },
    d: "M1898.587,934.523c-0.341,0-0.687-0.077-1.012-0.242 c-1.11-0.559-1.555-1.913-0.994-3.023c11.499-22.781,34.484-36.933,59.984-36.933c4.07,0,8.145,0.367,12.112,1.09 c1.223,0.223,2.034,1.395,1.811,2.617c-0.223,1.223-1.394,2.031-2.617,1.811c-3.703-0.676-7.506-1.017-11.306-1.017 c-23.792,0-45.237,13.205-55.967,34.461C1900.202,934.071,1899.41,934.523,1898.587,934.523z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -107.4386 1666.6432)",
    style: {
      opacity: 0.71,
      fill: "#FFFFFF"
    },
    cx: 1958.097,
    cy: 963.011,
    rx: 59.508,
    ry: 59.508
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165206366709384018590000015580963539384943508_",
    gradientUnits: "userSpaceOnUse",
    x1: 2001.1122,
    y1: 893.6683,
    x2: 1847.5132,
    y2: 1151.5358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165206366709384018590000015580963539384943508_)"
    },
    d: "M1952.257,1007.251v-6.474 c-6.749-0.27-13.425-1.863-18.166-3.939c-1.693-0.741-2.556-2.641-2.07-4.424l1.645-6.031c0.604-2.212,3.009-3.356,5.124-2.47 c4.703,1.972,10.511,3.532,16.773,3.532c6.5,0,11.349-2.204,11.349-6.722c0-4.076-3.746-6.5-12.781-8.924 c-12.891-3.526-22.146-9.145-22.146-20.494c0-10.247,7.493-18.07,20.494-20.163v-6.475c0-2.083,1.689-3.772,3.772-3.772h3.804 c2.083,0,3.772,1.689,3.772,3.772v5.813c6.245,0.25,10.791,1.318,14.399,2.586c1.848,0.649,2.858,2.641,2.346,4.531 l-1.512,5.577c-0.583,2.151-2.882,3.329-4.966,2.541c-3.322-1.256-8.018-2.564-14.122-2.564c-7.713,0-9.916,3.195-9.916,6.06 c0,3.526,4.627,5.949,14.654,9.035c14.323,4.297,20.273,10.247,20.273,20.934c0,9.806-7.271,18.621-21.375,20.824v7.245 c0,2.083-1.689,3.772-3.772,3.772h-3.804C1953.946,1011.023,1952.257,1009.334,1952.257,1007.251z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004528005866652494170000007390490718958173854_",
    gradientUnits: "userSpaceOnUse",
    x1: 1748.5367,
    y1: 1276.5631,
    x2: 2099.5681,
    y2: 1276.5631
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004528005866652494170000007390490718958173854_)"
    },
    d: "M2061.315,1117.924H1786.79 c-21.127,0-38.253,17.126-38.253,38.253v240.772c0,21.127,17.126,38.254,38.253,38.254h274.525 c21.127,0,38.253-17.126,38.253-38.254v-240.772C2099.568,1135.05,2082.442,1117.924,2061.315,1117.924z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116957377452915808640000002397493820360000957_",
    gradientUnits: "userSpaceOnUse",
    x1: 1905.969,
    y1: 1190.0565,
    x2: 1938.0823,
    y2: 1060.144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1780.04,
    y: 1095.422,
    style: {
      fill: "url(#SVGID_00000116957377452915808640000002397493820360000957_)"
    },
    width: 292.526,
    height: 24.752
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162312916169282975100000011350497135524038811_",
    gradientUnits: "userSpaceOnUse",
    x1: 1918.4369,
    y1: 934.9829,
    x2: 1924.437,
    y2: 1091.9833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162312916169282975100000011350497135524038811_)"
    },
    d: "M2068.77,1059.419h-289.435 c-7.068,0-12.797,5.729-12.797,12.796v19.411c0,7.067,5.729,12.797,12.797,12.797h289.435c7.068,0,12.797-5.729,12.797-12.797 v-19.411C2081.566,1065.148,2075.837,1059.419,2068.77,1059.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1781.816,1099.774c0,0.621-0.504,1.125-1.125,1.125l0,0c-0.621,0-1.125-0.504-1.125-1.125 v-33.753c0-0.621,0.504-1.125,1.125-1.125l0,0c0.621,0,1.125,0.504,1.125,1.125V1099.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1790.817,1099.774c0,0.621-0.504,1.125-1.125,1.125l0,0c-0.621,0-1.125-0.504-1.125-1.125 v-33.753c0-0.621,0.504-1.125,1.125-1.125l0,0c0.621,0,1.125,0.504,1.125,1.125V1099.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1799.818,1099.774c0,0.621-0.504,1.125-1.125,1.125l0,0c-0.621,0-1.125-0.504-1.125-1.125 v-33.753c0-0.621,0.504-1.125,1.125-1.125l0,0c0.621,0,1.125,0.504,1.125,1.125V1099.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1808.818,1099.774c0,0.621-0.504,1.125-1.125,1.125l0,0c-0.621,0-1.125-0.504-1.125-1.125 v-33.753c0-0.621,0.504-1.125,1.125-1.125l0,0c0.621,0,1.125,0.504,1.125,1.125V1099.774z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064335692623217422920000001643103536579087278_",
    gradientUnits: "userSpaceOnUse",
    x1: 1790.8167,
    y1: 1271.9144,
    x2: 2054.0903,
    y2: 1271.9144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064335692623217422920000001643103536579087278_)"
    },
    d: "M2054.09,1219.455 c0-7.067-5.729-12.796-12.797-12.796h-237.68c-7.067,0-12.797,5.729-12.797,12.796v104.919c0,7.067,5.729,12.796,12.797,12.796 h237.68c7.068,0,12.797-5.729,12.797-12.796V1219.455z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1809.292,1415.927h-22.877c-13.442,0-24.851-11.913-24.851-25.354v-74.631 c0-0.622,0.503-1.125,1.125-1.125s1.125,0.503,1.125,1.125v74.631c0,12.201,10.4,23.104,22.601,23.104h22.877 c0.622,0,1.125,0.503,1.125,1.125S1809.914,1415.927,1809.292,1415.927z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050632414930896458930000011128032553625073850_",
    gradientUnits: "userSpaceOnUse",
    x1: 1769.781,
    y1: 1766.4238,
    x2: 1891.2854,
    y2: 1371.5338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050632414930896458930000011128032553625073850_)"
    },
    d: "M1924.413,1259.346 c0,0,2.58-35.095,37.563-29.295c33.141,5.495,22.531,50.837-24.162,79.692c-5.062,3.129-11.332,3.588-16.808,1.26 c-20.501-8.717-68.251-33.682-41.915-68.353C1896.1,1220.261,1924.413,1259.346,1924.413,1259.346z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005967421672234272230000002824446581384317072_",
    gradientUnits: "userSpaceOnUse",
    x1: 1973.6621,
    y1: 898.0361,
    x2: 2122.2217,
    y2: 725.6013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000005967421672234272230000002824446581384317072_)"
    },
    cx: 2125.222,
    cy: 722.118,
    r: 110.757
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100384762759102505030000014574789000574011051_",
    gradientUnits: "userSpaceOnUse",
    x1: 2206.1672,
    y1: 599.8335,
    x2: 1766.8733,
    y2: 1263.4816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000100384762759102505030000014574789000574011051_)"
    },
    cx: 2125.222,
    cy: 722.118,
    r: 107.074
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.71,
      fill: "#FFFFFF"
    },
    d: "M2036.928,679.89c-0.341,0-0.687-0.077-1.012-0.242 c-1.11-0.559-1.555-1.913-0.994-3.023c17.31-34.294,51.912-55.598,90.3-55.598c6.124,0,12.26,0.552,18.235,1.64 c1.223,0.223,2.034,1.394,1.811,2.617c-0.222,1.224-1.391,2.025-2.617,1.811c-5.71-1.04-11.574-1.568-17.428-1.568 c-36.68,0-69.742,20.356-86.283,53.126C2038.543,679.438,2037.751,679.89,2036.928,679.89z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2145 -0.9767 0.9767 0.2145 963.6322 2647.1069)",
    style: {
      opacity: 0.71,
      fill: "#FFFFFF"
    },
    cx: 2127.555,
    cy: 724.451,
    rx: 90.625,
    ry: 90.625
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158711518906374335600000008079824061584234925_",
    gradientUnits: "userSpaceOnUse",
    x1: 2193.0627,
    y1: 618.8489,
    x2: 1959.1476,
    y2: 1011.5539
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158711518906374335600000008079824061584234925_)"
    },
    d: "M2118.662,791.823v-9.86 c-10.278-0.411-20.445-2.837-27.665-5.998c-2.578-1.129-3.893-4.022-3.152-6.738l2.505-9.184 c0.919-3.369,4.583-5.112,7.803-3.762c7.163,3.003,16.007,5.378,25.543,5.378c9.9,0,17.282-3.357,17.282-10.236 c0-6.208-5.704-9.899-19.464-13.59c-19.632-5.369-33.727-13.927-33.727-31.21c0-15.605,11.411-27.518,31.21-30.706v-9.861 c0-3.173,2.572-5.745,5.745-5.745h5.793c3.173,0,5.744,2.572,5.744,5.745v8.853c9.511,0.38,16.434,2.007,21.928,3.938 c2.815,0.989,4.353,4.021,3.572,6.901l-2.303,8.494c-0.888,3.275-4.389,5.069-7.563,3.869 c-5.058-1.913-12.21-3.905-21.507-3.905c-11.746,0-15.101,4.866-15.101,9.229c0,5.369,7.047,9.06,22.316,13.759 c21.813,6.544,30.874,15.604,30.874,31.88c0,14.933-11.074,28.357-32.551,31.713v11.034c0,3.173-2.572,5.745-5.745,5.745 h-5.794C2121.234,797.568,2118.662,794.996,2118.662,791.823z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114780216119986961910000014960872167717655692_",
    gradientUnits: "userSpaceOnUse",
    x1: 2233.9587,
    y1: 781.8646,
    x2: 2181.4829,
    y2: 942.7139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114780216119986961910000014960872167717655692_)"
    },
    d: "M2188.716,825.032l15.977-8.781 c6.75-3.711,11.611-10.109,13.375-17.607l4.032-17.135c0.121-0.514-0.105-1.047-0.559-1.318 c-0.454-0.27-1.03-0.215-1.425,0.136l-38.628,34.38c0,0-64.567,82.668,9.099,166.747l27.695-2.58 C2218.282,978.875,2164.969,893.271,2188.716,825.032z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073682202840972037880000003829170264261085115_",
    gradientUnits: "userSpaceOnUse",
    x1: 2216.8511,
    y1: 1309.7223,
    x2: 2314.6433,
    y2: 1309.7223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073682202840972037880000003829170264261085115_)"
    },
    d: "M2216.851,1219.445 c0,0,52.313,114.018,79.76,161.244c0,0,5.451,29.716,0,39.06l-4.646,2.065l21.682-0.645c0,0,1.926-39.971,0.422-42.203 c-1.504-2.233-4.512-2.086-4.512-2.086s-9.297-73.656-36.222-89.376l-26.093-89.873L2216.851,1219.445z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120559502217207652950000008009114267071104941_",
    gradientUnits: "userSpaceOnUse",
    x1: 2351.2693,
    y1: 1091.0291,
    x2: 2302.8394,
    y2: 1405.821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120559502217207652950000008009114267071104941_)"
    },
    d: "M2282.705,1427.412 c-0.032,0.523,16.931,0.284,26.145,0.116c3.403-0.062,6.303-2.453,7.028-5.778l6.959-36.558 c0.661-3.474-1.545-6.849-4.993-7.637l-3.884-0.888c0,0-5.541,7.601-3.797,14.757c1.744,7.156,3.297,25.694-1.112,27.854 c-4.408,2.16-17.087,2.537-17.087,2.537S2282.995,1422.704,2282.705,1427.412z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165930707873903196680000011487392403175511979_",
    gradientUnits: "userSpaceOnUse",
    x1: 2248.7969,
    y1: 1075.2627,
    x2: 2200.3667,
    y2: 1390.0574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165930707873903196680000011487392403175511979_)"
    },
    d: "M2167.267,1428.075 c-1.716,0.977-1.008,3.597,0.966,3.577c15.42-0.155,49.973-0.643,53.044-1.92c3.964-1.648-1.444-15.893-7.137-20.714 l-31.43,10.258L2167.267,1428.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018956573791828051280000003104089799413339580_",
    gradientUnits: "userSpaceOnUse",
    x1: 2157.5105,
    y1: 1316.9939,
    x2: 2214.1404,
    y2: 1316.9939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018956573791828051280000003104089799413339580_)"
    },
    d: "M2157.51,1212.174 c0,0,33.806,163.542,43.37,195.443l-22.623,14.197c0,0,11.337-1.928,19.744-2.537c8.407-0.609,16.14-10.258,16.14-10.258 l-2.71-4.323c0,0-8.478-162.651-6.414-181.121L2157.51,1212.174z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037690206553124975490000000145578633346394523_",
    gradientUnits: "userSpaceOnUse",
    x1: 2086.9651,
    y1: 704.3188,
    x2: 2088.9653,
    y2: 792.3188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037690206553124975490000000145578633346394523_)"
    },
    d: "M2073.593,830.712 c0,0-4.663,85.073,72.791,128.545l-18.647,42.529c0,0-70.124-42.415-67.531-158.096c0.074-3.32-1.123-6.544-3.291-9.059 l-14.904-17.29c-5.678-6.587-7.8-15.524-5.69-23.961l1.962-7.842c0.657-2.625,3.647-3.888,5.987-2.529l1.559,0.905 c4.962,2.882,8.892,7.25,11.235,12.488l7.318,16.359c2.733,6.111,9.036,9.821,15.706,9.245l4.525-0.391L2073.593,830.712z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127017383318253037530000002978631555248970880_",
    gradientUnits: "userSpaceOnUse",
    x1: 2153.5342,
    y1: 954.2548,
    x2: 2361.3782,
    y2: 1365.9072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127017383318253037530000002978631555248970880_)"
    },
    d: "M2221.552,973.391 c-2.884-3.865-7.238-6.365-12.03-6.907c-25.551-2.887-55.328-10.75-65.613-13.602c-2.095-0.581-4.264,0.581-4.958,2.641 l-13.36,40.875c-1.041,3.185,0.169,6.672,2.957,8.529l2.74,1.824c-1.994,5.923-4.614,12.083-1.094,17.247 c12.185,17.882,27.628,53.749,27.628,53.749l54.862,0.246l-1.339-15.487l13.4-75.617 C2225.588,982.141,2224.436,977.256,2221.552,973.391z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169544283692172270000000004608525966705774512_",
    gradientUnits: "userSpaceOnUse",
    x1: 2107.5125,
    y1: 1061.1649,
    x2: 2289.1235,
    y2: 1265.9818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169544283692172270000000004608525966705774512_)"
    },
    d: "M2153.205,1069.644l1.079,9.383 c0,0-15.504,46.43,7.752,154.874c0,0,50.366,14.269,91.763-19.875c0,0-11.677-102.354-14.867-107.122 c-15.887-23.747-26.47-28.909-26.47-28.909l-0.477-10.251C2211.986,1067.743,2167.71,1075.748,2153.205,1069.644z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160893216919170904740000000618702840117225107_",
    gradientUnits: "userSpaceOnUse",
    x1: 2174.6785,
    y1: 946.5499,
    x2: 2209.3325,
    y2: 946.5499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160893216919170904740000000618702840117225107_)"
    },
    d: "M2174.681,960.535 c-0.193-0.254,11.453-35.161,11.453-35.161l16.682,1.514l6.517,39.6C2209.333,966.487,2183.189,971.764,2174.681,960.535z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052080025967071732080000009569336868213307303_",
    gradientUnits: "userSpaceOnUse",
    x1: 5998.6899,
    y1: -2521.6858,
    x2: 6074.9917,
    y2: -2469.8582,
    gradientTransform: "matrix(0.92 0.3919 -0.3919 0.92 -4330.5166 857.5435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052080025967071732080000009569336868213307303_)"
    },
    d: "M2207.026,881.157 c0,0-17.056-0.053-35.782,16.649c-18.727,16.703-15.494,29.474-6.838,34.725c8.656,5.251,22.53,10.922,42.862,3.64 C2227.599,928.889,2228.899,881.925,2207.026,881.157z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116957232509873139620000000355451727744193207_",
    gradientUnits: "userSpaceOnUse",
    x1: 2326.7764,
    y1: 790.3813,
    x2: 2168.95,
    y2: 954.5844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116957232509873139620000000355451727744193207_)"
    },
    d: "M2215.296,868.172 c-19.762,1.138-24.375,16.594-24.375,16.594l8.274-1.741c23.042,10.18,8.878,30.61,4.295,36.311 c-0.725,0.901-0.718,2.183,0.02,3.073l0.025,0.031c0,0,8.613-3.836,8.932,2.518c0.32,6.354-10.162,13.512-10.162,13.512 s-0.318,13.954,15.714,8.357c16.033-5.597,26.144-18.062,28.563-43.003C2249.002,878.883,2235.059,867.033,2215.296,868.172z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069380947392851307290000016840695026673204119_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.6492,
    y1: 211.9122,
    x2: 331.106,
    y2: 211.9122,
    gradientTransform: "matrix(-0.8765 -0.4814 -0.4814 0.8765 2541.1682 924.7965)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069380947392851307290000016840695026673204119_)"
    },
    d: "M2248.605,934.194 c-8.71,28.07,12.153,30.536,18.076,48.405c9.599,28.961,47.933,25.593,65.712,57.806 c12.834,23.255,4.819,60.315-18.746,80.849c-32.638,28.44-85.368,18.549-102.566-5.017 c-16.437-22.523,3.77-51.848-19.417-80.203c-9.844-12.038-17.903-12.154-21.326-23.864 c-5.993-20.498,13.779-53.06,20.584-62.187c14.767-19.803,16.672-11.494,18.411-22.806 c3.384-22.002-24.558-34.713-20.05-49.082c4.107-13.084,38.971-23.013,58.303-7.814 C2277.497,893.795,2252.485,921.688,2248.605,934.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2307.134,1109.824c0.39,0.214,0.887,0.143,1.2-0.2c13.817-15.174,19.782-30.566,17.728-45.75 c-3.407-25.198-28.185-41.114-28.436-41.271c-0.368-0.29-1.063-0.153-1.355,0.307c-0.289,0.459-0.154,1.065,0.307,1.355 c0.243,0.153,24.263,15.6,27.538,39.888c1.967,14.576-3.832,29.43-17.236,44.147c-0.365,0.402-0.336,1.024,0.065,1.389 C2307.004,1109.742,2307.068,1109.788,2307.134,1109.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2214,1079.514c0.035,0.019,0.075,0.035,0.117,0.047c0.262,0.065,0.53-0.094,0.597-0.358 c4.543-17.996,3.347-32.884-3.55-44.25c-5.017-8.269-11.678-12.44-17.553-16.119c-5.665-3.549-10.557-6.615-12.638-12.463 c-4.3-12.09,6.056-29.794,30.781-52.619c0.2-0.184,0.211-0.495,0.027-0.695c-0.186-0.201-0.496-0.211-0.695-0.027 c-25.041,23.116-35.483,41.173-31.038,53.669c2.194,6.172,7.22,9.321,13.041,12.967c5.782,3.622,12.337,7.728,17.234,15.797 c6.756,11.131,7.912,25.767,3.436,43.5C2213.704,1079.185,2213.809,1079.409,2214,1079.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2230.232,925.985c0.034,0.039,0.073,0.073,0.122,0.103c0.233,0.138,0.535,0.058,0.673-0.175 c5.925-10.066-2.344-17.087-11.107-24.524c-5.547-4.707-11.277-9.576-13.999-15.562c-2.029-4.468-2.227-7.995-0.589-10.486 c2.786-4.243,10.067-4.161,10.141-4.162c0.272,0.006,0.495-0.211,0.5-0.481c0.007-0.27-0.211-0.495-0.482-0.499 c-0.321-0.006-7.89-0.095-10.98,4.6c-1.835,2.791-1.662,6.638,0.516,11.433c2.814,6.191,8.63,11.129,14.258,15.907 c8.794,7.467,16.402,13.92,10.894,23.276C2230.069,925.601,2230.098,925.83,2230.232,925.985z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164505413916197312630000011866306478713667003_",
    gradientUnits: "userSpaceOnUse",
    x1: 5996.3716,
    y1: -2533.1016,
    x2: 6083.7754,
    y2: -2473.7329,
    gradientTransform: "matrix(0.92 0.3919 -0.3919 0.92 -4330.5166 857.5435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164505413916197312630000011866306478713667003_)"
    },
    d: "M2202.475,923.2 c0,0,13.547-11.052,18.233-1.65c4.686,9.403-12.173,11.995-18.534,12.451L2202.475,923.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M379.012,621.792c-52.404,18.768-103.24,65.752-96.162,125.732 c6.019,51.005,64.546,66.062,100.051,71.437c9.903,1.499,18.901,6.575,25.327,14.258c15.378,18.385,48.319,49.026,84.47,28.629 c2.633-1.486,1.456-5.53-1.565-5.41c-9.61,0.381-23.25-1.002-32.532-10.033c-12.643-12.301-8.065-33.641,8.274-40.289 c30.922-12.58,89.269-46.83,81.714-124.449C538.372,576.695,379.012,621.792,379.012,621.792z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039091771401092221840000006856344395505330315_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.8717,
    y1: 717.1023,
    x2: 467.7532,
    y2: 717.1023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039091771401092221840000006856344395505330315_)"
    },
    d: "M410.923,705.511 c0,0,2.58-35.095,37.564-29.295c33.141,5.495,22.531,50.837-24.162,79.693c-5.062,3.128-11.332,3.588-16.808,1.26 c-20.501-8.717-68.251-33.682-41.914-68.353C382.61,666.426,410.923,705.511,410.923,705.511z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/Donate.66ffcd0bb1425a8ecdc954db62a2abbb.svg";
export { ForwardRef as ReactComponent };